<template>
  <!-- <fieldset disabled> -->
  <div class="engraving flex flex-dir--top">
    <breadcrumb
      :title="$route.query.line || $t('main.head.prodictionLine')"
      :childTitle="$t('common.engraving')"
      @goBackPage="goBackPage"
    >
      <template #title>
        <div class="top-nav">
          <span
            v-for="(item, index) in navList"
            :key="index"
            @click="changeNav(item)"
            :class="[nowPage == item.val ? 'active-nav' : '', 'nav-item']"
            :id="`equipment_engraving_nav_${item.val}_tab`"
          >
            <NewContent
              v-if="item.val === 'robotArmDocking'"
              :content="$translateLang('限免')"
              class="robot-arm-nav"
              :is-new-content="false"
            >
              <t-text :text="translateLang(item.name)" width="160px"></t-text>
            </NewContent>
            <t-text
              v-else
              :text="translateLang(item.name)"
              width="160px"
            ></t-text>
          </span>
        </div>
      </template>
      <div v-if="!previewInfo.isPreview">
        <!-- <a-button><a-icon type="form" />导入配置</a-button>
        <a-button><a-icon type="share-alt" />分享配置</a-button> -->
        <a-button
          @click.native="handleOpenChangeRecord"
          id="equipment_engraving_change_record"
        >
          <!-- 修改记录 -->
          {{ $t('common.modificationRecord') }}
        </a-button>
        <a-button
          type="primary"
          class="save-box ml20"
          @click.native="saveEngraving"
          :disabled="!ableSaveSetting"
          id="equipment_engraving_save_btn"
        >
          {{ $t('common.saveSetting') }}
        </a-button>
      </div>
      <div v-if="previewInfo.isApply">
        <!-- <a-button><a-icon type="form" />导入配置</a-button>
        <a-button><a-icon type="share-alt" />分享配置</a-button> -->
        <a-button
          type="primary"
          class="save-box ml20"
          @click.native="saveEngraving"
          :disabled="!ableSaveSetting"
          id="equipment_engraving_save_btn"
        >
          应用设置
        </a-button>
      </div>
    </breadcrumb>
    <div class="wrap flex-box--1 h0">
      <!-- 开料对接 -->
      <cuttingDock
        v-show="nowPage == 'cuttingDock'"
        ref="cutting_dock"
        :obj="allData.knivesSetting"
        :laserEnable="isLaserEnable"
        :ncExportSetting="allData.ncOutputSetting"
        :isShowSecondaryCatalog="isShowSecondaryCatalog"
        :knifeTypeOptions="knifeTypeOptions"
      ></cuttingDock>
      <!-- 切割参数 -->
      <cuttingParams
        v-show="nowPage == 'cuttingParams'"
        ref="cutting_params"
        :obj="allData.cuttingSetting"
        :isShowSecondaryCatalog="isShowSecondaryCatalog"
        @onHighGlossReverseChange="handleChangeHighGlossReverse"
      >
      </cuttingParams>
      <!-- 贴标设置 -->
      <labellingSetting
        v-show="nowPage == 'labellingSetting'"
        ref="labelling_setting"
        :obj="allData.labelingSetting"
        :paibanImgScale="paibanImgScale"
        :allLabelingList="allLabelingList"
        :labelNotOnline.sync="labelNotOnline"
        :isShowSecondaryCatalog="isShowSecondaryCatalog"
      >
      </labellingSetting>
      <!-- 排钻设置 -->
      <gangDrill
        v-show="nowPage == 'gangDrill'"
        ref="gang_drill"
        :obj="allData.drillingSetting"
        :ncExportSetting="allData.ncOutputSetting"
        :isShowSecondaryCatalog="isShowSecondaryCatalog"
      ></gangDrill>
      <!-- NC导出设置 -->
      <NcExportSetting
        v-show="nowPage == 'NcExportSetting'"
        ref="nc_export"
        :obj="allData.ncOutputSetting"
        :isShowSecondaryCatalog="isShowSecondaryCatalog"
      >
      </NcExportSetting>
      <AioMachineSetting
        v-show="nowPage == 'aioMachineSetting'"
        ref="aioMachine"
        :obj="allData.integrationDeviceSetting"
        :isShowSecondaryCatalog="isShowSecondaryCatalog"
        :knife-type-options="knifeTypeOptions"
      >
      </AioMachineSetting>
      <OneDragTwoEngraving
        v-show="nowPage == 'oneDragTwoEngraving'"
        ref="oneDragTwo"
        :obj="allData.oneForTwoDeviceSetting"
        :isShowSecondaryCatalog="isShowSecondaryCatalog"
      ></OneDragTwoEngraving>
      <!-- 锯切雕刻机 -->
      <SawEngraving
        v-show="nowPage == 'sawEngraving'"
        ref="sawEngraving"
        :obj="allData.sawSetting"
        :robotic-arm-setting="allData.robotic_arm_setting"
        :robotic-options="roboticArmOptions"
        :isShowSecondaryCatalog="isShowSecondaryCatalog"
      ></SawEngraving>
      <!-- 机械臂对接 -->
      <RobotArmDocking
        v-show="nowPage == 'robotArmDocking'"
        ref="robotArmDocking"
        :obj="allData.robotic_arm_setting"
        :isShowSecondaryCatalog="isShowSecondaryCatalog"
        @update:robotic-options="roboticArmOptions = $event"
      ></RobotArmDocking>
      <!-- 激光一体机 -->
      <LaserCuttingMachine
        :obj="allData.laser_setting"
        v-show="nowPage === 'laserCuttingMachine'"
        ref="laserCuttingMachine"
        :knifeTypeOptions="knifeTypeOptions"
        @changeLaserEnable="handleChangeLaserEnable"
      />
    </div>
    <m-lock-modal
      :visible.sync="isShowVisible"
      :status.sync="lockStatus"
      :verifyPassword="verifyPassword"
      :tempStatus.sync="tempStatus"
      codeType="bluen_update_production"
      @getLockPassword="handleGetLockPassword"
      @handleChangePasswordState="handleChangePasswordState"
      :lineName="$route.query.line"
    ></m-lock-modal>

    <!-- 修改记录弹窗 -->
    <m-change-record-modal
      :visible.sync="showRecordModal"
      operate_equipment="engraving"
      @success="handleSuccess"
      @needSaveVerify="handleNeedReductionSaveVerify"
      ref="recordModalRef"
    />
  </div>
  <!-- </fieldset> -->
</template>

<script>
import { fetchUserPermission } from '@/apis/auth'
import { getEquipmentPermission } from '@/apis/equipment'
import { getLockStatus } from '@/apis/productionLineLock'
import { checkUserPermissions } from '@/auth/user_function'
import NcExportSetting from '@/components/engraving/NcExportSetting.vue'
import AioMachineSetting from '@/components/engraving/aioMachineSetting.vue'
import cuttingDock from '@/components/engraving/cuttingDock.vue'
import cuttingParams from '@/components/engraving/cuttingParams.vue'
import gangDrill from '@/components/engraving/gangDrill.vue'
import labellingSetting from '@/components/engraving/labellingSetting.vue'
import LaserCuttingMachine from '@/components/engraving/laserCuttingMachine.vue'
import OneDragTwoEngraving from '@/components/engraving/oneDragTwoEngraving.vue'
import RobotArmDocking from '@/components/engraving/robotArmDocking.vue'
import SawEngraving from '@/components/engraving/sawEngraving.vue'
import { Navigate } from '@/components/g-search/utils'
import NewContent from '@/components/newContent.vue'
import breadcrumb from '@/components/topBreadCrumb.vue'
import { USER_PERMISSION_KEY } from '@/data/auth'
import store from '@/store'
import { translate } from '@/util/commonFun'
import {
  addIdForItems,
  buryPointApi, // compareDiffForm,
  flatObj,
  genFinalRecord,
  genFinalRecordPromise,
  genUniId,
  modalMsg,
  scrollToElementFn,
} from '@/util/commonFuncs.js'
import { operateRecordTableType, webId } from '@/util/configure'
import {
  AioMachineSettingTextObj,
  AioMachineSettingValueObj,
  LaserCuttingMachineTextObj,
  LaserCuttingMachineValueObj,
  NcExportSettingFormTextObj,
  NcExportSettingFormValueObj,
  OneDragTwoEngravingTextObj,
  OneDragTwoEngravingValueObj,
  RobotArmDockingTextObj,
  SawEngravingTextObj,
  SawEngravingValueObj,
  cuttingDockFormTextObj,
  cuttingDockFormValueObj,
  cuttingParamsFormTextObj,
  cuttingParamsFormValueObj,
  gangDrillFormTextObj,
  labellingSettingFormTextObj,
  labellingSettingFormValueObj,
} from '@/util/operateRecordConfigure/engravingConfigure'
import { saveDataJsonToOssForRecord } from '@/util/saveFile'
import MChangeRecordModal from '@/views/equipment/component/m-change-record-modal.vue'
import MLockModal from '@/views/equipment/component/m-lock-modal.vue'
import { message } from 'ant-design-vue'
import { mapActions, mapState } from 'vuex'

const compareMap = new Map([
  ['gt', translate('lineManager.greater')],
  ['lt', translate('lineManager.less')],
  ['eq', translate('lineManager.equal')],
])
export default {
  components: {
    breadcrumb,
    cuttingDock,
    gangDrill,
    cuttingParams,
    labellingSetting,
    LaserCuttingMachine,
    NcExportSetting,
    AioMachineSetting,
    OneDragTwoEngraving,
    MLockModal,
    MChangeRecordModal,
    SawEngraving,
    RobotArmDocking,
    NewContent,
  },

  data() {
    return {
      navList: [
        { name: 'cuttingDock.title', val: 'cuttingDock' },
        {
          name: 'cuttingDock.cuttingParams.title',
          val: 'cuttingParams',
        },
        {
          name: 'cuttingDock.labelingSettings.title',
          val: 'labellingSetting',
        },
        { name: 'cuttingDock.drillSettings.title', val: 'gangDrill' },
        {
          name: 'cuttingDock.NCExportSettings.title',
          val: 'NcExportSetting',
        },
        {
          name: 'cuttingDock.aioMachineSetting.title',
          val: 'aioMachineSetting',
        },
        {
          name: 'cuttingDock.oneDragTwo.title',
          val: 'oneDragTwoEngraving',
        },
        {
          name: 'cuttingDock.sawEngraving.title',
          val: 'sawEngraving',
        },
        {
          name: 'cuttingDock.robotArmDocking.autoLine',
          val: 'robotArmDocking',
        },
        {
          name: 'cuttingDock.laserCuttingMachine.title',
          val: 'laserCuttingMachine',
        },
      ],
      nowPage: 'cuttingDock',
      allData: {
        knivesSetting: {},
        cuttingSetting: {},
        labelingSetting: {},
        drillingSetting: {},
        ncOutputSetting: {},
        integrationDeviceSetting: {},
        oneForTwoDeviceSetting: {},
        robotic_arm_setting: {},
        laser_setting: {},
      },
      // 机械臂模板列表，由自动线对接加载后与锯切雕刻机共用
      roboticArmOptions: [],
      oriAllData: {},
      showTiangong: false,
      // 记录是否可以进行保存
      ableSaveSetting: false,
      // 记录所有的可选贴标机格式
      allLabelingList: [],
      // 记录当前贴标机格式是否在返回的贴标机列表中
      labelNotOnline: false,
      isShowVisible: false,
      lockStatus: 1, // 锁状态
      verifyPassword: true,
      tempStatus: 1, //默认状态
      showRecordModal: false,
      isReductionSaveVerify: false,
      isShowSecondaryCatalog: false, //是否显示二级目录，默认不勾选
      knifeTypeOptions: [],
      isLaserEnable: false, // 激光一体机是否开启
      isLaserPermission: false, // 激光一体机权限
    }
  },
  computed: {
    ...mapState(['userInfo', 'ncSetting']),
    ...mapState('equipEnvironment', ['previewProductLine', 'previewInfo']),
    paibanImgScale() {
      if (this.userInfo.panelSize) {
        let scale =
          this.userInfo.panelSize.plankHeight /
          this.userInfo.panelSize.plankWidth
        return scale
      } else {
        return 2
      }
    },
    // 特殊孔槽规则翻译映射
    translateMap() {
      return new Map([
        ['lightSlot', translate('common.lightSlot')],
        ['CCPXHole', translate('common.CCPXHole')],
        ['ALS', translate('common.ALS')],
        [
          'straightener_slots_and_hinged_cup_holes',
          translate('common.stretchHinge'),
        ],
        ['front', translate('common.front')],
        ['back', translate('common.back')],
        ['normalHole', '常规孔'],
        ['normalSlot', '常规槽'],
        ['normal_hole', '常规孔'],
        ['LockHole', '锁孔'],
      ])
    },
  },

  methods: {
    ...mapActions(['setNcSetting']),
    handleChangeHighGlossReverse(val) {
      this.$refs['nc_export'].handleChangeRollOverTag(val)
    },
    translateLang(key) {
      return translate(key)
    },
    async handleGetLockPassword() {
      if (this.isReductionSaveVerify) {
        this.isReductionSaveVerify = false
        const isSuccess = await this.$refs.recordModalRef?.handleDealReduction()
        if (isSuccess) {
          this.isShowVisible = false
        }
        return
      }
      await this.saveFun()
    },
    handleChangePasswordState(state) {
      this.verifyPassword = state
    },
    // 回到设备对接页面
    goBackPage() {
      this.nowPath = ''
      let path = ''
      if (this.showTiangong) {
        path = '/equipment?from=tiangong'
      } else {
        path = '/equipment'
      }
      if (this.previewInfo.isPreview) {
        path = `${path}-preview`
      }

      this.$router.push(path)
    },
    // 根据模板字符串生成自定义文件名
    genNameArrFromTemplateString(templateString) {
      let nameArr = templateString.match(/\{(.+?)\}/g)
      if (!nameArr) return
      for (let i = 0; i < nameArr.length; i++) {
        nameArr[i] = nameArr[i].replace(/\{|\}/g, '')
      }
      return nameArr
    },

    // 处理开料对接数据
    dealCuttingDockData() {
      let cutDockData = JSON.parse(
        JSON.stringify(this.$refs.cutting_dock.formData)
      )
      if (cutDockData.firstKnifPreStartCodeInsert === '') {
        cutDockData.firstKnifPreStartCodeInsert = -1
      }
      if (cutDockData.preStartCodeInsert === '') {
        cutDockData.preStartCodeInsert = -1
      }
      let s = cutDockData.knives.reduce((prev, cur) => {
        // 修改此处的顺序，解决首次保存时，转json与原始数据对比时，顺序不一致的问题
        prev[cur.desc] = {
          name: cur.name,
          desc: cur.desc,
          diameter: cur.diameter,
          type: cur.type,
          cutable: cur.cutable,
          slotable: cur.knifePurpose.includes('slotable'),
          holeable: cur.knifePurpose.includes('holeable'),
          millable: cur.knifePurpose.includes('millable'), // 该生产线第一次保存时，数据对比中，缺少该字段
          millableHole: cur.knifePurpose.includes('millableHole'),
          millableSlot: cur.knifePurpose.includes('millableSlot'),
          startCode: cur.startCode,
          stopCode: cur.stopCode,
          startCode2: cur.startCode2,
          stopCode2: cur.stopCode2,
          preStartCode: cur.preStartCode,
          // 速度字段可为英文/换行/空格等文本，不能再 Number 转换
          cutF: cur.cutF == null ? '' : String(cur.cutF),
          moveF: cur.moveF == null ? '' : String(cur.moveF),
          cutZF: cur.cutZF == null ? '' : String(cur.cutZF),
          moveZF: cur.moveZF == null ? '' : String(cur.moveZF),
          length: Number(cur.length) == 0 ? '' : Number(cur.length),
          maximum_single_depth:
            Number(cur.maximum_single_depth) == 0
              ? ''
              : Number(cur.maximum_single_depth),
          axis_offset: cur.axis_offset,
          arc_radius: cur.arc_radius,
          [webId]: cur[webId],
        }
        return prev
      }, {})
      cutDockData.knives = s
      return cutDockData
    },
    handleChangeLaserEnable(val) {
      this.isLaserEnable = val
    },
    // 处理激光一体机数据
    dealLaserCuttingMachineData() {
      let laserCuttingMachineData = JSON.parse(
        JSON.stringify(this.$refs.laserCuttingMachine.formData)
      )
      let s = laserCuttingMachineData.back_knives.reduce((prev, cur) => {
        prev[cur.desc] = {
          desc: cur.desc,
          name: cur.name,
          diameter: cur.diameter,
          type: cur.type,
          cutable: cur.cutable,
          slotable: cur.knifePurpose?.includes('slotable') || false,
          holeable: cur.knifePurpose?.includes('holeable') || false,
          millableHole: cur.knifePurpose?.includes('millableHole') || false,
          millableSlot: cur.knifePurpose?.includes('millableSlot') || false,
          startCode: cur.startCode,
          stopCode: cur.stopCode,
          cutF: Number(cur.cutF) == 0 ? '' : Number(cur.cutF),
          moveF: Number(cur.moveF) == 0 ? '' : Number(cur.moveF),
          cutZF: Number(cur.cutZF) == 0 ? '' : Number(cur.cutZF),
          moveZF: Number(cur.moveZF) == 0 ? '' : Number(cur.moveZF),
          [webId]: cur[webId] || genUniId(),
        }
        return prev
      }, {})
      laserCuttingMachineData.back_knives = s
      return laserCuttingMachineData
    },
    // 处理切割参数数据
    dealCuttingParamsData() {
      this.$refs.cutting_params.saveAccordmCut()
      this.$refs.cutting_params.syncObliqueThickListToRanges?.()
      // 这里处理下数据
      let cutParam = JSON.parse(
        JSON.stringify(this.$refs.cutting_params.formData)
      )
      const specialHoleAndSlotTableRules =
        this.$refs.cutting_params?.$refs.SpecialHoleAndSlotTable?.getAllRules() ?? {
          is_open: false,
          special_hole_slot_side: [],
        }

      // // 为什么要在这收集所有的特殊孔槽的规则,因为这里可以统一收集所有的规则 只做一次收集动作 为什么不用map:Map在JSON.stringify时会清空
      if (specialHoleAndSlotTableRules.is_open) {
        cutParam.holeFaceSetting.custom_special_hole_slot_side =
          specialHoleAndSlotTableRules
      }

      // 不生效翻面两次打穿孔槽 同上
      const specialHoleAndSlotTableRules2 =
        this.$refs.cutting_params?.$refs.specialHoleSlotRef?.getAllRules() ?? {
          is_open: false,
          special_hole_slot_side: [],
        }
      if (specialHoleAndSlotTableRules2.is_open) {
        cutParam.cuttingPunchingSetting.non_through_slot_two_side_cut =
          specialHoleAndSlotTableRules2
      }

      cutParam.trimmingSetting.secondTrimValue = Number(
        cutParam.trimmingSetting.secondTrimValue
      )
      cutParam.cuttingPunchingSetting.idleZ = Number(
        cutParam.cuttingPunchingSetting.idleZ
      )
      cutParam.cuttingPunchingSetting.cutZ = Number(
        cutParam.cuttingPunchingSetting.cutZ
      )
      cutParam.processingSpeedSetting.knifeSpeed = Number(
        cutParam.processingSpeedSetting.knifeSpeed
      )
      cutParam.processingSpeedSetting.open_knife_distance = Number(
        cutParam.processingSpeedSetting.open_knife_distance
      )
      cutParam.processingSpeedSetting.arcSpeed = Number(
        cutParam.processingSpeedSetting.arcSpeed
      )
      cutParam.movePlankSetting.safe_length =
        cutParam.movePlankSetting.safe_length.map((item) => Number(item))
      let angleDecelerationList = []
      for (
        let index = 0;
        index < cutParam.processingSpeedSetting.angle_deceleration_list.length;
        index++
      ) {
        if (
          cutParam.processingSpeedSetting.angle_deceleration_list[index]
            .flat(1)
            .every((e) => Number(e)) ||
          (cutParam.processingSpeedSetting.angle_deceleration_list.length ==
            1 &&
            !index) ||
          (cutParam.processingSpeedSetting.angle_deceleration_list[index]
            .flat(1)
            .every((e) => !Number(e)) &&
            !index)
        ) {
          angleDecelerationList.push(
            cutParam.processingSpeedSetting.angle_deceleration_list[index].map(
              (item) => {
                return Number(item)
              }
            )
          )
        }
      }
      // 对angleDecelerationList调整顺序 二维数组
      if (
        angleDecelerationList.length > 1 &&
        angleDecelerationList[0][0] > angleDecelerationList[1][0]
      ) {
        angleDecelerationList = angleDecelerationList.sort((a, b) => {
          return a[0] - b[0]
        })
      }
      cutParam.processingSpeedSetting.angle_deceleration_list =
        angleDecelerationList
      this.$refs.cutting_params.formData.processingSpeedSetting.angle_deceleration_list =
        cutParam.processingSpeedSetting.angle_deceleration_list
      if (
        !this.judgeangleDeceleration(
          cutParam.processingSpeedSetting.angle_deceleration_list
        )
      )
        return
      cutParam.processingSpeedSetting.angle_deceleration_dis = Number(
        cutParam.processingSpeedSetting.angle_deceleration_list[0][0]
      )
      cutParam.processingSpeedSetting.angle_deceleration_speed = Number(
        cutParam.processingSpeedSetting.angle_deceleration_list[0][1]
      )
      cutParam.layeredCuttingSetting.minSafeLength = Number(
        cutParam.layeredCuttingSetting.minSafeLength
      )
      cutParam.layeredCuttingSetting.minSafeArea = Number(
        cutParam.layeredCuttingSetting.minSafeArea
      )
      cutParam.layeredCuttingSetting.minSafeThick = Number(
        cutParam.layeredCuttingSetting.minSafeThick
      )
      cutParam.layeredCuttingSetting.secondCuttingDepth = Number(
        cutParam.layeredCuttingSetting.secondCuttingDepth
      )
      cutParam.decimalSetting.decimal = Number(cutParam.decimalSetting.decimal)
      cutParam.coedgeCuttingSetting.coedgeSpeed = Number(
        cutParam.coedgeCuttingSetting.coedgeSpeed
      )
      cutParam.coedgeCuttingSetting.coedgeThick = Number(
        cutParam.coedgeCuttingSetting.coedgeThick
      )
      cutParam.boardGapsSetting.boardGap = Number(
        cutParam.boardGapsSetting.boardGap
      )
      cutParam.mentaojiSizeSetting.mentaojiSize = Number(
        cutParam.mentaojiSizeSetting.mentaojiSize
      )
      if (
        !cutParam.longPlankCuttingSetting.longPlankMinLength &&
        cutParam.longPlankCuttingSetting.longPlankMinLength != 0
      ) {
        cutParam.longPlankCuttingSetting.longPlankMinLength = ''
      }
      if (
        !cutParam.longPlankCuttingSetting.longPlankExpandedSize &&
        cutParam.longPlankCuttingSetting.longPlankExpandedSize != 0
      ) {
        cutParam.longPlankCuttingSetting.longPlankExpandedSize = ''
      } else {
        cutParam.longPlankCuttingSetting.longPlankExpandedSize = Number(
          cutParam.longPlankCuttingSetting.longPlankExpandedSize
        )
      }
      if (
        cutParam.longPlankCuttingSetting.longPlankShortExpandedSize ||
        cutParam.longPlankCuttingSetting.longPlankShortExpandedSize == 0
      ) {
        cutParam.longPlankCuttingSetting.longPlankShortExpandedSize = Number(
          cutParam.longPlankCuttingSetting.longPlankShortExpandedSize
        )
      }
      if (cutParam.coedgeCuttingSetting.coedgeAccelerate) {
        if (
          !cutParam.coedgeCuttingSetting.coedgeSpeed ||
          cutParam.coedgeCuttingSetting.coedgeSpeed == 0
        ) {
          this.$message({
            message: this.$t('cuttingDock.upSpeedTip'),
            type: 'error',
          })
          return
        }
      }
      if (cutParam.coedgeCuttingSetting.coedgeCutting) {
        if (
          !cutParam.coedgeCuttingSetting.coedgeThick ||
          cutParam.coedgeCuttingSetting.coedgeThick == 0
        ) {
          this.$message({
            message: this.$t('cuttingDock.cutThickTip'),
            type: 'error',
          })
          return
        }
      }
      cutParam.processingSpeedSetting.noOblique =
        !cutParam.processingSpeedSetting.noOblique

      delete cutParam.holeFaceSetting.processChainAndHoleOnBigPlaneBack
      return cutParam
    },
    // 处理贴标参数数据
    dealLabellingSettingData() {
      let labelingSetting = JSON.parse(
        JSON.stringify(this.$refs.labelling_setting.formData)
      )

      for (
        let i = 0;
        i < labelingSetting.layoutImageSetting.layoutImage.length;
        ++i
      ) {
        let paibanImg = labelingSetting.layoutImageSetting.layoutImage[i]
        if (paibanImg.enable) {
          if (
            paibanImg.imageSize[0] == '' ||
            paibanImg.imageSize[0] == 0 ||
            paibanImg.imageSize[1] == '' ||
            paibanImg.imageSize[1] == 0 ||
            paibanImg.imageSize[2] == '' ||
            paibanImg.imageSize[2] == 0
          ) {
            this.$message({
              message: this.$t('cuttingDock.sizeErrTip'),
              type: 'error',
            })
            return
          }
        }
      }
      let labellingSetting = JSON.parse(
        JSON.stringify(this.$refs.labelling_setting.formData)
      )
      if (!labellingSetting.label_picture_delimiter) {
        labellingSetting.label_picture_delimiter = 'underline'
      } else {
        labellingSetting.label_picture_delimiter = 'none'
      }

      return labellingSetting
    },
    // 是否可以保存设置
    checkIsCanSaveSetting() {
      return (
        this.$refs.labelling_setting.formData.label_image_name_type.length &&
        !this.$refs.nc_export.isContainsSpecialChars &&
        !this.$refs.nc_export.isNullFileSide &&
        !this.$refs.labelling_setting.checkTagRotateOffset
      )
    },
    // 是否可以保存设置 单面板
    checkIsCanSaveSettingSingle(cutParam, oneDragTwoData) {
      return (
        (cutParam.trimmingSetting.is_first_trim_single_panel &&
          !cutParam.trimmingSetting.single_panel_trim_direction &&
          !cutParam.trimmingSetting.is_single_panel_four_trim) ||
        (oneDragTwoData.enableOneForTwoDevice &&
          oneDragTwoData.one_for_two_trimming_setting.one_for_two_trim &&
          oneDragTwoData.one_for_two_trimming_setting
            .one_for_two_single_panel_trim &&
          !oneDragTwoData.one_for_two_trimming_setting
            .one_for_two_single_panel_trim_direction &&
          !oneDragTwoData.one_for_two_trimming_setting
            .one_for_two_is_single_panel_four_trim)
      )
    },
    // 一体机设置
    dealAioMachineData() {
      if (
        !this.$refs.aioMachine.formData.trimming_knife_diameter &&
        this.$refs.aioMachine.formData.yitiji_machine_name == 'ruinuo'
      ) {
        this.$message({
          message: this.$t('cuttingDock.offEdgeKnifeDiameter'),
          type: 'error',
        })
        return false
      }
      // 一体机刀具编号重复或为空判断
      const knivesNameList =
        this.$refs.aioMachine.formData.anc_setting.knives.map(
          (item) => item.name
        )
      if (
        new Set(knivesNameList).size !== knivesNameList.length ||
        knivesNameList.some((item) => item == '')
      ) {
        this.$message.error('一体机刀具库编号重复或为空，请重新输入保存')
        return
      }
      const aioMachineData = JSON.parse(
        JSON.stringify({
          ...this.$refs.aioMachine.formData,
          aioOptions: this.$refs.aioMachine.aioOptions,
        })
      )
      let s = aioMachineData.anc_setting.knives.reduce((prev, cur) => {
        // 修改此处的顺序，解决首次保存时，转json与原始数据对比时，顺序不一致的问题
        prev[cur.name] = {
          name: cur.name,
          diameter: cur.diameter,
          type: cur.type,
          slotable: cur.use.includes('slotable'),
          holeable: cur.use.includes('holeable'),
          trim_able: cur.use.includes('trim_able'),
          irregular_milling: cur.use.includes('irregular_milling'),
          use: cur.use,
          startCode: cur.startCode,
          stopCode: cur.stopCode,
          cutF: Number(cur.cutF) == 0 ? '' : Number(cur.cutF),
          moveF: Number(cur.moveF) == 0 ? '' : Number(cur.moveF),
          cutZF: Number(cur.cutZF) == 0 ? '' : Number(cur.cutZF),
          moveZF: Number(cur.moveZF) == 0 ? '' : Number(cur.moveZF),
          xOffset: Number(cur.xOffset) == 0 ? '' : Number(cur.xOffset),
          yOffset: Number(cur.yOffset) == 0 ? '' : Number(cur.yOffset),
          zOffset: Number(cur.zOffset) == 0 ? '' : Number(cur.zOffset),
          axis_offset: cur.axis_offset,
          arc_radius: cur.arc_radius,
          [webId]: cur[webId],
        }
        return prev
      }, {})
      aioMachineData.anc_setting.knives = s
      return aioMachineData
    },
    // 一拖二雕刻机
    dealOneDragTwoData() {
      let oneDragTwoData = JSON.parse(
        JSON.stringify(this.$refs.oneDragTwo.formData)
      )
      if (
        !this.$refs.oneDragTwo?.formData?.one_for_two_trimming_setting
          ?.one_for_two_trim
      ) {
        oneDragTwoData.trimmingSetting = JSON.parse(
          JSON.stringify(this.$refs.cutting_params.formData.trimmingSetting)
        )
        delete oneDragTwoData.trimmingSetting.trimSideInBluenNcSettings
      }
      return oneDragTwoData
    },
    // 处理NC导出设置
    dealNcExportSettingData() {
      let ncExportData = JSON.parse(
        JSON.stringify(this.$refs.nc_export.formData)
      )
      if (
        ncExportData.fileNameSetting.customizeSetting.hasOwnProperty(
          'stockNumLength'
        )
      ) {
        delete ncExportData.fileNameSetting.customizeSetting.stockNumLength
      }
      ncExportData.fileNameSetting.stockNumLength = Number(
        ncExportData.fileNameSetting.stockNumLength
      )
      return ncExportData
    },
    // 比较开料对接
    compareCuttingDock(current, ori) {
      // let record = []
      // 当前数据
      // const current = data.knivesSetting
      // 原始数据
      // const ori = oriData.knivesSetting
      // ------------
      // 门套机原始table、当前table

      const currentTableList = Object.values(current.knives)
      const oriTableList = Object.values(ori.knives)
      // 给record添加表格操作记录
      // addOperateTableToRecord(
      //   currentTableList, // 当前板件列表
      //   oriTableList, // 原始板件列表
      //   Object.keys(currentTableList[0]),
      //   operateRecordTableType.KNIFE_STORE_TABLE,
      //   '刀库',
      //   record
      // )
      let compareMsg = [
        {
          title: '其他',
          keys: ['autoSendStockCode', 'pauseCode', 'evenAutoSendStockCode'],
        },
        {
          title: '设备类型',
          keys: ['single_double_station'],
        },
        {
          title: '双工位不同换刀开始代码',
          keys: ['open_two_station_code'],
        },
        {
          title: '工位开始',
          keys: ['oddBeginCode', 'evenBeginCode'],
        },
        {
          title: '正反面开始',
          keys: ['beginCodeF', 'beginCodeB'],
        },
        {
          title: '正反面结束',
          keys: ['endCodeF', 'endCodeB'],
        },
        {
          title: '板件翻面',
          keys: ['rollCode', 'evenRollCode'],
        },
        {
          title: '自动下料代码',
          keys: ['oddAutoBaitingCode', 'evenAutoBaitingCode'],
        },
        {
          title: '工位结束',
          keys: ['oddEndCode', 'evenEndCode'],
        },
        {
          title: '预启动设备',
          keys: ['firstKnifPreStartCodeInsert', 'preStartCodeInsert'],
        },
        {
          title: '真空泵暂停',
          keys: ['oddVacuumPumpPauseCode', 'evenVacuumPumpPauseCode'],
        },
        {
          title: '正面注释代码',
          keys: ['first_front_annotation_code', 'second_front_annotation_code'],
        },
        {
          title: '门套机',
          keys: ['mentaoji_enable'],
        },
      ]
      const generateCodes = (settings, source) => {
        return settings.reduce((acc, key) => {
          acc[key.replace('Setting', '')] = source[key]?.template_string || ''
          return acc
        }, {})
      }
      // 公共设置数组
      const settings = [
        'autoSendStockCodeSetting',
        'pauseCodeSetting',
        'evenAutoSendStockCodeSetting',
        'oddBeginCodeSetting',
        'evenBeginCodeSetting',
        'beginCodeFSetting',
        'beginCodeBSetting',
        'endCodeFSetting',
        'endCodeBSetting',
        'rollCodeSetting',
        'evenRollCodeSetting',
        'oddAutoBaitingCodeSetting',
        'evenAutoBaitingCodeSetting',
        'oddEndCodeSetting',
        'evenEndCodeSetting',
        // 'firstFrontAnnotationCodeSetting',
        // 'secondFrontAnnotationCodeSetting',
      ]
      // 更新 current 对象
      current = { ...current, ...generateCodes(settings, current) }

      // 更新 ori 对象
      ori = { ...ori, ...generateCodes(settings, ori) }
      {
        let first_front_annotation_code =
          current.firstFrontAnnotationCodeSetting?.template_string || ''
        let second_front_annotation_code =
          current.secondFrontAnnotationCodeSetting?.template_string || ''
        current = {
          ...current,
          first_front_annotation_code,
          second_front_annotation_code,
        }
      }
      {
        let first_front_annotation_code =
          ori.firstFrontAnnotationCodeSetting?.template_string || ''
        let second_front_annotation_code =
          ori.secondFrontAnnotationCodeSetting?.template_string || ''
        ori = {
          ...ori,
          first_front_annotation_code,
          second_front_annotation_code,
        }
      }
      const currentThickMarkList =
        current.big_plank_thickness_marking_range || []
      const oriThickMarkList = ori.big_plank_thickness_marking_range || []
      const thickMarkKeys = Object.keys(
        currentThickMarkList[0] ||
          oriThickMarkList[0] || {
            min_thick: '',
            max_thick: '',
            thick_mark: '',
          }
      )
      return {
        key: '开料对接',
        dataArr: [
          {
            type: 'table',
            list: currentTableList,
            oriList: oriTableList,
            keys: Object.keys(currentTableList[0]),
            tableType: operateRecordTableType.KNIFE_STORE_TABLE,
            excludeKeys: ['millable'],
            key: '刀库',
          },
          {
            type: 'table',
            list: currentThickMarkList,
            oriList: oriThickMarkList,
            keys: thickMarkKeys,
            tableType: operateRecordTableType.BIG_PLANK_THICKNESS_MARKING_RANGE,
            key: '大板厚度标识',
          },
          {
            type: 'form',
            current,
            ori,
            compareMsg,
            formTextObj: cuttingDockFormTextObj,
            formValueObj: cuttingDockFormValueObj,
          },
        ],
      }
    },
    /** 操作记录对比前归一化斜下刀字段，避免 UI 中间态/旧版存储格式误报 */
    normalizeObliqueSettingForRecord(cuttingSetting) {
      const ps = cuttingSetting?.processingSpeedSetting
      if (!ps) {
        return
      }
      if (typeof ps.noOblique === 'boolean') {
        // noOblique 存储与 UI 反向，操作记录按勾选语义展示
        ps.noOblique = !ps.noOblique
      }
      if (
        ps.oblique_thick_setting_switch === undefined &&
        ps.back_oblique_thick_setting_switch !== undefined
      ) {
        ps.oblique_thick_setting_switch = ps.back_oblique_thick_setting_switch
      }
      const thickSwitchOn = Boolean(
        ps.oblique_thick_setting_switch || ps.back_oblique_thick_setting_switch
      )
      ps.oblique_thick_setting_switch = thickSwitchOn
      ps.back_oblique_thick_setting_switch = thickSwitchOn
      if (!ps.oblique_cut_range || typeof ps.oblique_cut_range !== 'object') {
        ps.oblique_cut_range = {
          plank_thicks: [],
          back_trim_thicks: [],
          hole_slot_thicks: [],
        }
      }
      const hasNewRange =
        ps.oblique_cut_range.plank_thicks?.length ||
        ps.oblique_cut_range.back_trim_thicks?.length ||
        ps.oblique_cut_range.hole_slot_thicks?.length
      if (!hasNewRange) {
        if (ps.oblique_thick_thick_range?.length) {
          ps.oblique_cut_range.plank_thicks = ps.oblique_thick_thick_range
        }
        if (ps.back_oblique_thick_thick_range?.length) {
          ps.oblique_cut_range.back_trim_thicks =
            ps.back_oblique_thick_thick_range
        }
        if (ps.hole_slot_cut_oblique_thick_range?.length) {
          ps.oblique_cut_range.hole_slot_thicks =
            ps.hole_slot_cut_oblique_thick_range
        }
      }
      if (ps.oblique_thick_list?.length && !hasNewRange) {
        ps.oblique_cut_range.plank_thicks = ps.oblique_thick_list.map(
          (item) => item?.cut ?? ''
        )
        ps.oblique_cut_range.back_trim_thicks = ps.oblique_thick_list.map(
          (item) => item?.back_trim ?? ''
        )
        ps.oblique_cut_range.hole_slot_thicks = ps.oblique_thick_list.map(
          (item) => item?.hole_slot ?? ''
        )
      }
      delete ps.oblique_thick_list
      delete ps.oblique_thick_thick_range
      delete ps.back_oblique_thick_thick_range
      delete ps.hole_slot_cut_oblique_thick_range
    },
    // 比较切割参数
    compareCuttingParams(current, ori) {
      // const record = []
      const normalizedCurrent = JSON.parse(JSON.stringify(current))
      const normalizedOri = JSON.parse(JSON.stringify(ori))
      this.normalizeObliqueSettingForRecord(normalizedCurrent)
      this.normalizeObliqueSettingForRecord(normalizedOri)
      // 当前数据铺平
      const currentFlat = flatObj(normalizedCurrent)
      // 原始数据铺平
      const oriFlat = flatObj(normalizedOri)
      currentFlat.prevent_breakage_enable =
        current.cuttingPunchingSetting?.prevent_breakage_setting?.enable ??
        false
      oriFlat.prevent_breakage_enable =
        ori.cuttingPunchingSetting?.prevent_breakage_setting?.enable ?? false
      delete currentFlat.prevent_breakage_setting
      delete oriFlat.prevent_breakage_setting
      if (currentFlat.desMaterialList)
        currentFlat.desMaterialList = `"${currentFlat.desMaterialList.join(
          ','
        )}"`
      if (oriFlat.desMaterialList)
        oriFlat.desMaterialList = `"${oriFlat.desMaterialList.join(',')}"`
      const compareMsg = [
        {
          title: '孔槽集中面',
          keys: [
            'holeConcentrated',
            'apertureSlotConcentrated',
            'throughHoleSlotSameSide',
            'percentage_of_back_hole_slot',
            'prorate_holes_slots_of_both_side',
            'isSpecialHoleSlot',
            'hs_on_front_aft_shunt', // 孔槽分流中设置的特殊孔槽优先排在大板正面功能
            'cal_turn_num_aft_shunt', // 在孔槽分流后计算翻版次数
          ],
        },
        {
          title: '靠边板槽放置',
          keys: ['sideBoardPlacing'],
        },
        {
          title: '共边切割',
          keys: ['coedgeCutting', 'coedgeThick'],
        },
        {
          title: '共边加速',
          keys: ['coedgeAccelerate', 'coedgeSpeed'],
        },
        {
          title: '台面设置',
          keys: [
            'startPosition',
            'xyReverse',
            'auto_adaptation_xy_reverse',
            'doubleStationReverse',
            'planeOffset',
            'planeXOffset',
            'planeYOffset',
            'planeZOffset',
            'X_reference_swap',
            'x_reverse_reference_swap',
            'y_reverse_reference_swap',
            'doubleDifferentSize',
            'counter_width',
            'counter_limit_able',
            'stationOneMax',
            'stationTwoMax',
            'smallStationFirst',
            'one_for_two_start_position',
          ],
        },
        {
          title: '修边设置',
          keys: [
            'is_double_panel_four_trim',
            'trimSide',
            'trimLSingle',
            'double_panel_trim_short',
            'trimLMoment',
            'secondTrimValue',
            'new_trim',
            'is_first_trim_single_panel',
            'single_panel_trim_direction',
            'is_single_panel_four_trim',
            'trim_compensation',
            'is_zero_no_route',
          ],
        },
        {
          title: '余料设置',
          keys: ['surplusPosition'],
        },
        {
          title: '高光设置',
          keys: [
            'highgloss_direction',
            'auto_high_gloss_reverse',
            'high_gloss_plank_no_rotate',
          ],
        },
        {
          title: '切割打孔方式',
          keys: [
            'zReference',
            'idleZ',
            'knifeBasedOnPlank',
            'cutZ',
            'throughTowSideToCut',
            'cutDirection',
            'clock_dir_switch',
            'cut_internal_curve_dir',
            'mill_hole_slot_dir',
            'cuttingCurvedInterpolationCommand',
            'noG17G18G19',
            'arcInstruction',
            'arcCuttingCode',
            'autoClearFilletSlot',
            'mill_slots_way',
            'through_slot_two_side_cut',
            'z_shape_processed_through_slot',
            'mill_z_slot_overlap_rate',
            'min_knife_change',
            'isSpecialThroughTwoSideToCut',
            'prevent_breakage_enable',
          ],
        },
        {
          title: '加工速度优化',
          keys: [
            'noOblique',
            'oblique_thick_setting_switch',
            'oblique_cut_range',
            'back_trim_oblique',
            'hole_slot_cut_oblique',
            'obliqueSpeed',
            'hole_slot_oblique_speed',
            'knifeSpeed',
            'open_knife_distance',
            'arcSpeed',
            'cuttingPreDistance',
            'angle_deceleration_enabled',
            'angle_deceleration_dis',
            'angle_deceleration_speed',
            'openknifeSpeed',
            'retraction_compensation',
            'angle_deceleration_list',
            'small_plank_cut_switch',
            'small_plank_cut_rule',
            'oblique_distance',
            'hole_slot_oblique_distance',
          ],
        },
        {
          title: '分层切割',
          keys: [
            'repeatedSlot',
            'repeatedCut',
            'rect_plank_cutting_method',
            'minSafeLength',
            'minSafeArea',
            'minSafeThick',
            'secondCuttingDepth',
            'millingSlotOverlapRate',
            'layered_slot_cutting',
            'layered_slot_lt_knife_diameter',
            'layered_slot_gt_slot_deep',
            'layered_slot_second_slot_deep',
            'curve_layered_cutting',
            'curve_layered_cutting_deep',
          ],
        },
        {
          title: '长板加工',
          keys: [
            'longPlankCuttingEnable',
            'longPlankMinLength',
            'longPlankShortMinLength',
            'cutSingleDoor',
            'cutGeneralPlank',
            'generalPlankThick',
            'single_door_thick',
            'specified_board_secondary_cutting',
            'force_board_name',
            'secondary_cutting_board_list',
            'longPlankExpandedSize',
            'longPlankShortExpandedSize',
            'vacuumPumpPauseWay',
            'curveSecondCutEnable',
            'desMaterialSwitch',
            'desMaterialList',
          ],
        },

        {
          title: '小数保留位数',
          keys: ['decimal'],
        },
        {
          title: '下刀缓冲指令设置',
          keys: [
            'plankSurfaceBufferCommand',
            'hole_surface_buffer',
            'hole_slot_surface_buffer',
            'buffer_way',
            'buffer_offset',
          ],
        },
        {
          title: '排版间隙设置',
          keys: ['boardGap'],
        },
        {
          title: '开料分层切割设置',
          keys: ['isLayeredCut', 'trimmingFollowsLayeredCutting'],
        },
        {
          title: '防跑板设置',
          keys: [
            'newCutSequence',
            'strong_suction_zones',
            'safe_length',
            'scattered_layout',
            'lastPlankCutPointEnable',
            'lastPlankCutPoint',
            'bridgeRetention',
          ],
        },
        {
          title: '废料自动截断',
          keys: [
            'waste_cutting',
            'waste_size',
            'waste_order',
            'waste_vertical_direction',
            'waste_horizontal_direction',
          ],
        },
        {
          title: 'Z扣斜孔加工旋转基准点自定义',
          keys: [
            'ZK_datum_point_customize',
            'rotate_base_point',
            'rotate_angle_direction',
          ],
        },
      ]
      const currentTableList = current.layeredThickSetting.layeredThicks
      const oriTableList = ori.layeredThickSetting.layeredThicks
      // 搭桥留点法-生成方式表格（排除后不再走 form 比对）
      // 无 webId 时用下标兜底，避免新旧数据分别 genId 后整表被识别为删+增
      const formatBridgeCountRules = (list) =>
        (list || []).map((item, index) => ({
          webId: item.webId || `bridge_rule_fallback_${index}`,
          plankLength: `${item.minLength} < L ≤ ${item.maxLength}`,
          count: item.count,
        }))
      const currentBridgeRules = formatBridgeCountRules(
        current.movePlankSetting?.bridgeRetention?.bridgeCountRules
      )
      const oriBridgeRules = formatBridgeCountRules(
        ori.movePlankSetting?.bridgeRetention?.bridgeCountRules
      )
      if (currentFlat.bridgeRetention) {
        const { bridgeCountRules, ...bridgeRetentionRest } =
          currentFlat.bridgeRetention
        currentFlat.bridgeRetention = bridgeRetentionRest
      }
      if (oriFlat.bridgeRetention) {
        const { bridgeCountRules, ...bridgeRetentionRest } =
          oriFlat.bridgeRetention
        oriFlat.bridgeRetention = bridgeRetentionRest
      }
      // 特殊孔槽自定义规则表格
      const currentSpecialSlotHoleList =
        current.holeFaceSetting.custom_special_hole_slot_side.special_hole_slot_side.map(
          (it) => {
            const curKey = it.key.replace(/\d+$/, '')
            const rules = it.rules
            const o = {
              webId: it?.webId ?? 'webId',
              specialHoleSlot: this.translateMap.get(curKey),
              side: this.translateMap.get(it.value),
            }
            if (curKey === 'normalHole') {
              o.diameter = compareMap.get(rules.compare) + rules.value
            }
            if (curKey === 'normalSlot') {
              o.long_side = `${rules.long_side_compare}${rules.long_side_value}`
              o.short_side = `${rules.short_side_compare}${rules.short_side_value}`
            }
            return o
          }
        )
      const oriSpecialSlotHoleList =
        ori.holeFaceSetting.custom_special_hole_slot_side.special_hole_slot_side.map(
          (it) => {
            const curKey = it.key.replace(/\d+$/, '')
            const rules = it.rules
            const o = {
              webId: it?.webId ?? 'webId',
              specialHoleSlot: this.translateMap.get(curKey),
              side: this.translateMap.get(it.value),
            }
            if (curKey === 'normalHole') {
              o.diameter = compareMap.get(rules.compare) + rules.value
            }
            if (curKey === 'normalSlot') {
              o.long_side = `${rules.long_side_compare}${rules.long_side_value}`
              o.short_side = `${rules.short_side_compare}${rules.short_side_value}`
            }
            return o
          }
        )

      // 不生效翻面两次打穿孔槽自定义规则表格
      const currentSpecialThroughTwoSideToCutList =
        current.cuttingPunchingSetting.non_through_slot_two_side_cut.special_hole_slot_side.map(
          (it) => {
            const curKey = it.key.replace(/\d+$/, '')
            const rules = it.rules
            const o = {
              webId: it?.webId ?? 'webId',
              specialHoleSlot: this.translateMap.get(curKey),
            }
            if (curKey === 'normal_hole') {
              o.diameter = compareMap.get(rules.compare) + rules.value
            }
            return o
          }
        )
      const oriSpecialThroughTwoSideToCutList =
        ori.cuttingPunchingSetting.non_through_slot_two_side_cut.special_hole_slot_side.map(
          (it) => {
            const curKey = it.key.replace(/\d+$/, '')
            const rules = it.rules
            const o = {
              webId: it?.webId ?? 'webId',
              specialHoleSlot: this.translateMap.get(curKey),
            }
            if (curKey === 'normal_hole') {
              o.diameter = compareMap.get(rules.compare) + rules.value
            }
            return o
          }
        )

      const getPreventBreakageRuleWebId = (rule, index, refRules = []) => {
        if (rule?.[webId]) {
          return rule[webId]
        }
        if (rule?.id) {
          return rule.id
        }
        if (refRules[index]?.[webId]) {
          return refRules[index][webId]
        }
        return `prevent_breakage_${index}`
      }
      const formatPreventBreakageRules = (rules = [], refRules = []) =>
        (rules || []).map((rule, index) => ({
          webId: getPreventBreakageRuleWebId(rule, index, refRules),
          edge_distance: this.formatPreventBreakageRange(rule.edge_distance),
          edge_part_length: this.formatPreventBreakageRange(rule.length),
          slot_depth: this.formatPreventBreakageRange(rule.deep),
          first_cut_deep:
            rule.cut_deep !== '' && rule.cut_deep != null
              ? String(rule.cut_deep)
              : '',
        }))
      const currentPreventBreakageRuleList =
        current.cuttingPunchingSetting?.prevent_breakage_setting?.rules || []
      const oriPreventBreakageRuleList =
        ori.cuttingPunchingSetting?.prevent_breakage_setting?.rules || []
      const currentPreventBreakageRules = formatPreventBreakageRules(
        currentPreventBreakageRuleList
      )
      const oriPreventBreakageRules = formatPreventBreakageRules(
        oriPreventBreakageRuleList,
        currentPreventBreakageRuleList
      )
      return {
        // key: '开料对接',
        key: '切割参数',
        dataArr: [
          {
            type: 'form',
            current: currentFlat,
            ori: oriFlat,
            compareMsg,
            formTextObj: {
              ...cuttingParamsFormTextObj,
              trimSide: !currentFlat.double_panel_trim_short
                ? '修边方向'
                : '定位气缸方向',
            },
            formValueObj: cuttingParamsFormValueObj,
          },
          {
            type: 'table',
            list: currentTableList,
            oriList: oriTableList,
            keys: [
              'matCode',
              'highlight',
              'pThick',
              'firstCut',
              'secondCut',
              'thirdCut',
            ],
            tableType: operateRecordTableType.CUTTING_PARAMS_PLANK_TABLE,
            key: '开料分层切割设置',
          },
          {
            type: 'table',
            list: currentSpecialSlotHoleList,
            oriList: oriSpecialSlotHoleList,
            keys: ['specialHoleSlot', 'side'], // diameter, long_side, short_side 这里应该有这个值修改的操作记录 不确定是否需要处理
            tableType:
              operateRecordTableType.CUSTOM_SPECIAL_HOLE_SLOT_SIDE_TABLE,
            key: '特殊孔槽加工面自定义',
          },
          {
            type: 'table',
            list: currentSpecialThroughTwoSideToCutList,
            oriList: oriSpecialThroughTwoSideToCutList,
            keys: ['specialHoleSlot', 'diameter'], // diameter, long_side, short_side 这里应该有这个值修改的操作记录 不确定是否需要处理
            tableType:
              operateRecordTableType.CUSTOM_THROUGH_TWO_SIDE_TO_CUT_TABLE,
            key: '设置不生效翻面两次打穿孔',
          },
          {
            type: 'table',
            list: currentPreventBreakageRules,
            oriList: oriPreventBreakageRules,
            keys: [
              'edge_distance',
              'edge_part_length',
              'slot_depth',
              'first_cut_deep',
            ],
            tableType: operateRecordTableType.PREVENT_BREAKAGE_RULES_TABLE,
            key: '边缘槽隔条防断',
          },
          {
            type: 'table',
            list: currentBridgeRules,
            oriList: oriBridgeRules,
            keys: ['plankLength', 'count'],
            tableType: operateRecordTableType.BRIDGE_COUNT_RULES_TABLE,
            key: '搭桥留点法-生成方式',
          },
        ],
      }
    },
    formatPreventBreakageRange(range) {
      if (!Array.isArray(range) || range.length < 2) {
        return ''
      }
      const start = range[0] ?? ''
      const end = range[1] ?? ''
      if (start === '' && end === '') {
        return ''
      }
      return `${start}-${end}`
    },
    // 比较贴标设置
    compareLabellingSetting(current, ori) {
      // const record = []
      // 当前数据铺平
      const currentFlat = flatObj(current)
      // 原始数据铺平
      const oriFlat = flatObj(ori)
      const compareMsg = [
        {
          title: '', // 输出自动贴标文件
          keys: ['labelingMachine'],
        },
        {
          title: '翻面贴标设置', // 反面贴标设置
          keys: ['labelOverturn'],
        },
        {
          title: '贴标文件格式',
          keys: ['labelFormat', 'label_after_send_stock'], // 这个要处理一下
        },
        {
          title: '自动贴标顺序设置',
          keys: ['labelingOrder'],
        },
        {
          title: '贴标自动避让',
          keys: ['labelingDodge'],
        },
        {
          title: '余料大板不生成贴标文件',
          keys: ['no_gen_labelling_file_to_surplus'],
        },
        {
          title: '标签旋转设置',
          keys: [
            'rotateLabel',
            'horizontal',
            'criticalValue',
            'parallel_plank',
            'parallel_approach',
            'effective_object',
          ],
        },
        {
          title: '台面设置',
          keys: ['labelingStartPosition', 'xDatumSwap', 'yDatumSwap'],
        },
        {
          title: '贴标坐标偏移',
          keys: ['labelXOffset', 'labelYOffset'],
        },
        {
          title: '标签旋转后坐标偏移',
          keys: [
            'offsetAfterLabelRotation',
            'xOffsetAfterLabelRotation',
            'yOffsetAfterLabelRotation',
          ],
        },
        {
          title: '贴标图片设置',
          keys: [
            'labelImageFormat',
            'labelImageFormatNew',
            'bmp_color_style',
            'label_picture_delimiter',
            'label_resolution',
            'num_auto_offset',
            'label_image_name_separator',
            'front_labeling_start_num',
            'stockNumOffset',
            'label_img_big_plank_folder',
            'labeling_file_insert',
          ],
        },
        {
          title: '贴标图片名',
          keys: ['label_image_name_type'],
        },
        {
          title: 'PDF贴标设置',
          keys: ['pdf_label_name', 'pdf_label_name_separator'],
        },
      ]

      let labellingSettingFormValueObjTemp = JSON.parse(
        JSON.stringify(labellingSettingFormValueObj)
      )
      let obj = {}
      this.allLabelingList.forEach((item) => {
        obj[item.labelFormat] = item.modelName
      })
      // 添加一下 labelFormat 对应的value值（因为是动态的）
      labellingSettingFormValueObjTemp['labelFormat'] = obj

      // const formChangeArr = compareDiffForm(
      //   currentFlat,
      //   oriFlat,
      //   compareMsg,
      //   labellingSettingFormTextObj,
      //   labellingSettingFormValueObjTemp
      // )
      // if (formChangeArr.length) {
      //   record.push(...formChangeArr)
      // }

      // const imageDirectionValueObj = {
      //   vert: '竖向',
      //   horiz: '横向',
      // }
      const currentTableList = current.layoutImageSetting.layoutImage
      // currentTableList.forEach((item) => {
      //   item.imageDirection = imageDirectionValueObj[item.imageDirection]
      // })

      const oriTableList = ori.layoutImageSetting.layoutImage
      // oriTableList.forEach((item) => {
      //   item.imageDirection = imageDirectionValueObj[item.imageDirection]
      // })

      // 给record添加表格操作记录
      // addOperateTableToRecord(
      //   currentTableList, // 当前板件列表
      //   oriTableList, // 原始板件列表
      //   [
      //     'enable',
      //     'imageNamePrefix',
      //     'imageSize',
      //     'imageFormat',
      //     'imageDirection',
      //   ],
      //   operateRecordTableType.LAYOUT_SETTINGS_TABLE,
      //   '排版图设置',
      //   record
      // )
      // return record
      return {
        key: '贴标设置',
        dataArr: [
          {
            type: 'form',
            current: currentFlat,
            ori: oriFlat,
            compareMsg,
            formTextObj: labellingSettingFormTextObj,
            formValueObj: labellingSettingFormValueObjTemp,
          },
          {
            type: 'table',
            list: currentTableList,
            oriList: oriTableList,
            keys: [
              'enable',
              'imageNamePrefix',
              'imageSize',
              'imageFormat',
              'imageDirection',
            ],
            tableType: operateRecordTableType.LAYOUT_SETTINGS_TABLE,
            key: '排版图设置',
            idKey: 'webId',
          },
        ],
      }
    },
    // 比较排钻设置
    compareGangDrill(current, ori) {
      // const record = []
      const currentTableList = current.drills
      const oriTableList = ori.drills

      //排钻组合下刀从孔表格数据
      const currentGangDrillCombinationAuxiliaryList =
        current.gangDrillCombinationAuxiliaryList
      const oriGangDrillCombinationAuxiliaryList =
        ori.gangDrillCombinationAuxiliaryList

      // 给record添加表格操作记录
      // addOperateTableToRecord(
      //   currentTableList, // 当前板件列表
      //   oriTableList, // 原始板件列表
      //   [
      //     'isUsed',
      //     'number',
      //     'diameter',
      //     'xOffset',
      //     'yOffset',
      //     'moveZF',
      //     'feedRate',
      //     'moveF',
      //     '_selected',
      //   ],
      //   operateRecordTableType.KNIFE_TOOL_TABLE,
      //   '刀具列表',
      //   record
      // )

      const compareMsg = [
        {
          title: '启用排钻包',
          keys: ['enabled'],
        },
        {
          title: '',
          keys: ['prefix', 'suffix', 'beginCode', 'endCode'],
        },
        {
          title: '排钻组合下刀',
          keys: [
            'gangDrillCombinationEnable',
            'gangDrillCombinationMainPrefix',
            'gangDrillCombinationMainSuffix',
            'gangDrillCombinationComment',
            'gangDrillCombinationuCommentFirstSign',
          ],
        },
        {
          title: '加工设置',
          keys: ['drill_process_mode', 'drill_benchmark'],
        },
      ]

      // 比较form的不同项
      // const formChangeArr = compareDiffForm(
      //   current,
      //   ori,
      //   compareMsg,
      //   gangDrillFormTextObj
      // )
      // if (formChangeArr.length) {
      //   record.push(...formChangeArr)
      // }
      // return record
      const generateCodes = (settings, source) => {
        return settings.reduce((acc, key) => {
          // 因为后端更改了数据格式，旧数据可能是字符串/对象两种情况
          acc[key] =
            typeof source[key] === 'string'
              ? source[key]
              : source[key]?.template_string || ''
          return acc
        }, {})
      }

      const settings = [
        'gangDrillCombinationMainPrefix',
        'gangDrillCombinationMainSuffix',
        'gangDrillCombinationComment',
        'gangDrillCombinationuCommentFirstSign',
      ]

      // 更新 current 对象
      current = { ...current, ...generateCodes(settings, current) }

      // 更新 ori 对象
      ori = { ...ori, ...generateCodes(settings, ori) }
      const knifeKeys = ['knifePrefix', 'knifeSuffix']
      // 处理currentGangDrillCombinationAuxiliaryList和oriGangDrillCombinationAuxiliaryList
      const newCurrent = currentGangDrillCombinationAuxiliaryList.map(
        (item) => {
          return {
            ...item,
            ...generateCodes(knifeKeys, item),
          }
        }
      )
      const newOri = oriGangDrillCombinationAuxiliaryList.map((item, idx) => {
        return {
          ...item,
          // 这个很蠢，但是由于新的排钻这边的设置是这样决定的名称，代码源 ganDrill.vue -> line = 597
          name: `从孔${idx + 1}`,
          ...generateCodes(knifeKeys, item),
        }
      })

      return {
        key: '排钻设置',
        dataArr: [
          {
            type: 'table',
            list: currentTableList,
            oriList: oriTableList,
            keys: [
              'isUsed',
              'number',
              'number2',
              'diameter',
              'xOffset',
              'yOffset',
              'moveZF',
              'feedRate',
              'moveF',
              '_selected',
            ],
            tableType: operateRecordTableType.KNIFE_TOOL_TABLE,
            key: '刀具列表',
            idKey: '',
            tableIdentify: 'number',
          },
          {
            type: 'table',
            list: newCurrent,
            oriList: newOri,
            keys: ['knifePrefix', 'knifeSuffix', 'name'],
            tableType:
              operateRecordTableType.SIDE_HOLE_DRILL_SETTING_DRILL_COMBINATION_FROM_HOLE_TABLE,
            key: '从孔列表',
            idKey: '',
            tableIdentify: 'number',
            excludeKeys: ['name'],
          },
          {
            type: 'form',
            current,
            ori,
            compareMsg,
            formTextObj: gangDrillFormTextObj,
            // formValueObj: labellingSettingFormValueObjTemp
          },
        ],
      }
    },
    // 比较NC导出文件
    compareNcExportSetting(current, ori) {
      // 当前数据铺平
      let currentFlat = flatObj(current)
      // 原始数据铺平
      let oriFlat = flatObj(ori)
      // 单独输出工艺选项映射
      const singleFileOptionMap = {
        arcStraightSlot: '圆弧部分直槽',
        handleSlope: '斜边海棠角和斜边拉手',
        curveHole: '内部异形',
        hole: '常规孔',
        slot: '常规槽',
      }
      const operatorLabelMap = {
        '==': '等于',
        '<': '小于',
        '>': '大于',
        '<=': '小于等于',
        '>=': '大于等于',
      }
      // 保留/补齐 webId；优先按 webId 对齐，其次按内容对齐，避免按索引配对在删除时错位
      const alignListWebIds = (newList, oriList, isSameContent) => {
        const usedOriIndexes = new Set()
        newList.forEach((newItem) => {
          if (!newItem[webId]) return
          const matchedIndex = oriList.findIndex(
            (oriItem, index) =>
              !usedOriIndexes.has(index) &&
              oriItem[webId] &&
              oriItem[webId] === newItem[webId]
          )
          if (matchedIndex > -1) {
            usedOriIndexes.add(matchedIndex)
          }
        })
        newList.forEach((newItem) => {
          const matchedById =
            !!newItem[webId] &&
            oriList.some(
              (oriItem, index) =>
                usedOriIndexes.has(index) && oriItem[webId] === newItem[webId]
            )
          if (matchedById) return
          const matchedIndex = oriList.findIndex(
            (oriItem, index) =>
              !usedOriIndexes.has(index) && isSameContent(newItem, oriItem)
          )
          if (matchedIndex > -1) {
            const sharedId =
              oriList[matchedIndex][webId] || newItem[webId] || genUniId()
            newItem[webId] = sharedId
            oriList[matchedIndex][webId] = sharedId
            usedOriIndexes.add(matchedIndex)
            return
          }
          newItem[webId] = newItem[webId] || genUniId()
        })
        oriList.forEach((oriItem, index) => {
          if (!usedOriIndexes.has(index)) {
            oriItem[webId] = oriItem[webId] || genUniId()
          }
        })
      }
      const formatHoleRangeList = (list = []) =>
        (list || []).map((item) => ({
          [webId]: item?.[webId],
          hole_operator:
            operatorLabelMap[item?.operator] ?? item?.operator ?? '',
          hole_value:
            item?.value === '' ||
            item?.value === undefined ||
            item?.value === null
              ? ''
              : String(item.value),
        }))
      const formatSlotRangeList = (list = []) =>
        (list || []).map((item) => ({
          [webId]: item?.[webId],
          slot_length_operator:
            operatorLabelMap[item?.slot_length?.operator] ??
            item?.slot_length?.operator ??
            '',
          slot_length_value:
            item?.slot_length?.value === '' ||
            item?.slot_length?.value === undefined ||
            item?.slot_length?.value === null
              ? ''
              : String(item.slot_length.value),
          slot_width_operator:
            operatorLabelMap[item?.slot_width?.operator] ??
            item?.slot_width?.operator ??
            '',
          slot_width_value:
            item?.slot_width?.value === '' ||
            item?.slot_width?.value === undefined ||
            item?.slot_width?.value === null
              ? ''
              : String(item.slot_width.value),
        }))
      const holeRangeList = formatHoleRangeList(
        current.singleFileSetting?.holeRange
      )
      const oriHoleRangeList = formatHoleRangeList(
        ori.singleFileSetting?.holeRange
      )
      alignListWebIds(
        holeRangeList,
        oriHoleRangeList,
        (a, b) =>
          a.hole_operator === b.hole_operator && a.hole_value === b.hole_value
      )
      const slotRangeList = formatSlotRangeList(
        current.singleFileSetting?.slotRange
      )
      const oriSlotRangeList = formatSlotRangeList(
        ori.singleFileSetting?.slotRange
      )
      alignListWebIds(
        slotRangeList,
        oriSlotRangeList,
        (a, b) =>
          a.slot_length_operator === b.slot_length_operator &&
          a.slot_length_value === b.slot_length_value &&
          a.slot_width_operator === b.slot_width_operator &&
          a.slot_width_value === b.slot_width_value
      )

      currentFlat = {
        ...currentFlat,
        nameArr: this.genNameArrFromTemplateString(
          currentFlat.customizeSetting.templateString
        ),
        beforePlankAddCustomizeInfo:
          currentFlat?.beforePlankAddCustomizeInfo?.template_string,
        processTypes: currentFlat?.processTypes?.map(
          (item) => singleFileOptionMap[item] ?? ''
        ),
        curveHoleFileName:
          currentFlat?.customFilename?.curveHole?.template_string,
        arcStraightSlotFileName:
          currentFlat?.customFilename?.arcStraightSlot?.template_string,
        handleSlopeFileName:
          currentFlat?.customFilename?.handleSlope?.template_string,
        holeFileName: currentFlat?.customFilename?.hole?.template_string,
        slotFileName: currentFlat?.customFilename?.slot?.template_string,
        mergeFileNameTemplateString:
          currentFlat?.mergeFileName?.template_string,
      }
      oriFlat = {
        ...oriFlat,
        nameArr: this.genNameArrFromTemplateString(
          oriFlat.customizeSetting.templateString
        ),
        beforePlankAddCustomizeInfo:
          oriFlat?.beforePlankAddCustomizeInfo?.template_string,
        processTypes: oriFlat?.processTypes?.map(
          (item) => singleFileOptionMap[item] ?? ''
        ),
        curveHoleFileName: oriFlat?.customFilename?.curveHole?.template_string,
        arcStraightSlotFileName:
          oriFlat?.customFilename?.arcStraightSlot?.template_string,
        handleSlopeFileName:
          oriFlat?.customFilename?.handleSlope?.template_string,
        holeFileName: oriFlat?.customFilename?.hole?.template_string,
        slotFileName: oriFlat?.customFilename?.slot?.template_string,
        mergeFileNameTemplateString: oriFlat?.mergeFileName?.template_string,
      }
      // 修边埋点
      if (
        JSON.stringify(currentFlat.trim_direction_list) !=
        JSON.stringify(oriFlat.trim_direction_list)
      ) {
        const dirArr = ['top', 'bottom', 'left', 'right']
        currentFlat.trim_direction_list.forEach((item, index) => {
          if (item != oriFlat.trim_direction_list[index]) {
            buryPointApi('engraving', `trim_side_${dirArr[index]}`)
          }
        })
      }
      // 大板长度标识埋点
      if (
        JSON.stringify(currentFlat.big_plank_length_marking_range) !=
        JSON.stringify(oriFlat.big_plank_length_marking_range)
      ) {
        buryPointApi('engraving', 'big_plank_length_marking_range')
      }
      // 文件名数据埋点
      if (
        JSON.stringify(currentFlat.nameArr) != JSON.stringify(oriFlat.nameArr)
      ) {
        currentFlat.nameArr.forEach((item) => {
          buryPointApi('engraving', `custom_name_${item}`)
        })
      }
      // 应急设置埋点
      if (
        JSON.stringify(current.emergencySetting) !=
        JSON.stringify(ori.emergencySetting)
      ) {
        buryPointApi('equipment_dock', 'modify_emergency_setting')
      }
      // const record = []
      const compareMsg = [
        {
          title: '开料机文件名设置',
          keys: [
            'doubleStationSortName',
            'is_generate_process_sort_number',
            'stockNumLength',
            'labelMachineName',
            'machineCenterName',
            'front',
            'back',
            'nameArr',
            'hasDelimiter',
            'front_info',
            'back_info',
            'trim_direction_list',
            'custom_high_gloss_reverse',
          ],
        },
        {
          title: '开料机文件合并',
          keys: [
            'doubleEdgeCombine',
            'bEnd1',
            'fBegin1',
            'displayfbInfo',
            'doubleStationCombine',
            'bBegin2',
            'bEnd2',
            'fBegin2',
            'fEnd2',
            'singleStationCombine',
            'bBegin3',
            'bEnd3',
            'fBegin3',
            'fEnd3',
          ],
        },
        {
          title: '开料机文件中注释',
          keys: [
            'beforePlankAddInfo',
            'beforePlankAddCustomizeInfo',
            'beforePlank',
            'beforeStartKnife',
          ],
        },
        {
          title: '开料机文件中类型',
          keys: [
            'alwaysZ',
            'semicolon',
            'exportUsingBanlu',
            'exportFormat',
            'exportFormatAnnotation',
            'fileNameType',
            'always_back_nc',
            'fileExtensionName',
          ],
        },
        {
          title: '开料机文件夹',
          keys: [
            'useCategoryFolder',
            'same_size_sheet_cutting_files',
            'label_image_in_nc_folder',
          ],
        },
        {
          title: '加工指令设置',
          keys: ['GCommandShorthand', 'z_to_w_normal', 'z_to_w_gang_drill'],
        },
        {
          title: '文件格式设置',
          keys: ['platform', 'fileEncoding', 'fileSuffix'],
        },
        {
          title: '板件条码设置',
          keys: [
            'genSimpleLabelBarcode',
            'uniqueBarCode',
            'uniqueBarCodeForPack',
          ],
        },
        {
          title: '代码位置设置',
          keys: ['stationEndCodeBeforeEndCodeB'],
        },
        // {
        //   title: '应急设置',
        //   keys: ['settingKey', 'param1', 'param2', 'param3'],
        // },
        {
          title: '打孔文件设置',
          keys: ['output56FDrillSortByCode'],
        },
        {
          title: '单独文件加工设置',
          keys: [
            'handleSlope',
            'straight_arc_slot',
            'enable',
            'processTypes',
            'curveHoleFileName',
            'arcStraightSlotFileName',
            'handleSlopeFileName',
            'holeFileName',
            'slotFileName',
            'mergeFile',
            'mergeFileNameTemplateString',
          ],
        },
      ]

      // 比较form的不同项
      // const formChangeArr = compareDiffForm(
      //   currentFlat,
      //   oriFlat,
      //   compareMsg,
      //   NcExportSettingFormTextObj,
      //   NcExportSettingFormValueObj
      // )
      // if (formChangeArr.length) {
      //   record.push(...formChangeArr)
      // }
      // return record
      return {
        key: 'NC导出设置',
        dataArr: [
          {
            type: 'form',
            current: currentFlat,
            ori: oriFlat,
            compareMsg,
            formTextObj: NcExportSettingFormTextObj,
            formValueObj: NcExportSettingFormValueObj,
          },
          {
            type: 'table',
            list: current.emergencySetting,
            oriList: ori.emergencySetting,
            keys: Object.keys(current.emergencySetting[0]),
            tableType: operateRecordTableType.EMERGENCY_SETTING,
            excludeKeys: ['settingKey'],
            key: '应急设置',
          },
          {
            type: 'table',
            list: current.fileNameSetting.big_plank_length_marking_range,
            oriList: ori.fileNameSetting.big_plank_length_marking_range,
            keys: Object.keys(
              current.fileNameSetting.big_plank_length_marking_range[0]
            ),
            tableType: operateRecordTableType.BIG_PLANK_LENGTH_MARKING_RANGE,
            key: '大板长度标识',
          },
          {
            type: 'table',
            list: holeRangeList,
            oriList: oriHoleRangeList,
            keys: ['hole_operator', 'hole_value'],
            tableType: operateRecordTableType.SINGLE_FILE_HOLE_RANGE,
            key: '孔生效范围',
          },
          {
            type: 'table',
            list: slotRangeList,
            oriList: oriSlotRangeList,
            keys: [
              'slot_length_operator',
              'slot_length_value',
              'slot_width_operator',
              'slot_width_value',
            ],
            tableType: operateRecordTableType.SINGLE_FILE_SLOT_RANGE,
            key: '槽生效范围',
          },
        ],
      }
    },
    // 比较一拖二雕刻机
    compareOneDragTwoEngraving(current, ori) {
      const compareMsg = [
        {
          title: '输出一拖二雕刻机加工文件',
          keys: ['enableOneForTwoDevice'],
        },
        {
          title: '文件格式',
          keys: ['oneForTwoMachineName'],
        },
        {
          title: '工位起始点',
          keys: [
            'enable_one_for_two_start_position',
            'one_for_two_start_position',
          ],
        },
        {
          title: '修边设置',
          keys: [
            'one_for_two_is_double_panel_four_trim',
            'one_for_two_double_panel_trim_short',
            'one_for_two_trim',
            'one_for_two_trim_side',
            'one_for_two_trim_single',
            'one_for_two_trim_moment',
            'one_for_two_second_trim_value',
            'one_for_two_new_trim',
            'one_for_two_single_panel_trim',
            'one_for_two_single_panel_trim_direction',
            'one_for_two_is_single_panel_four_trim',
            'one_for_two_trim_compensation',
            'one_for_two_is_zero_no_route',
          ],
        },
        {
          title: '其他',
          keys: ['secondAutoSendStockCode', 'secondPauseCode'],
        },
        {
          title: '工位开始',
          keys: ['secondOddBeginCode', 'secondEvenBeginCode'],
        },
        {
          title: '正反面开始',
          keys: ['secondBeginCodeF', 'secondBeginCodeB'],
        },
        {
          title: '正反面结束',
          keys: ['secondEndCodeF', 'secondEndCodeB'],
        },
        {
          title: '板件翻面',
          keys: ['secondRollCode', 'secondEvenRollCode'],
        },
        {
          title: '工位结束',
          keys: ['secondOddEndCode', 'secondEvenEndCode'],
        },
      ]
      return {
        key: '一拖二雕刻机',
        dataArr: [
          {
            type: 'form',
            current: { ...current, ...current.one_for_two_trimming_setting },
            ori: { ...ori, ...ori.one_for_two_trimming_setting },
            compareMsg,
            formTextObj: {
              ...OneDragTwoEngravingTextObj,
              one_for_two_trim_side: !current.one_for_two_trimming_setting
                .one_for_two_is_double_panel_four_trim
                ? '修边方向'
                : '定位气缸方向',
            },
            formValueObj: OneDragTwoEngravingValueObj,
          },
        ],
      }
    },
    // 比较一体机
    compareAioMachineSetting(current, ori) {
      const compareMsg = [
        {
          title: '输出一体机加工文件',
          keys: ['enable_integration_device'],
        },
        {
          title: '文件格式',
          keys: ['yitiji_machine_name'],
        },
        {
          title: '修边刀具直径',
          keys: ['trimming_knife_diameter'],
        },
        {
          title: '显示数据样例',
          keys: ['is_display_sample'],
        },
        {
          title: '自定义铣孔铣槽/内部异形切割方向',
          keys: ['enable'],
        },
        {
          title: '铣孔铣槽方向',
          keys: ['mill_hole_slot_dir'],
        },
        {
          title: '内部异形切割方向',
          keys: ['cut_internal_curve_dir'],
        },
        {
          title: '程序开始代码',
          keys: ['anc_begin_code'],
        },
        {
          title: '程序结束代码',
          keys: ['anc_end_code'],
        },
        {
          title: '孔槽避让夹手位置',
          keys: ['aio_avoid_fixture'],
        },
        {
          title: '夹手长度',
          keys: ['aio_fixture_length'],
        },
        {
          title: '夹手宽度',
          keys: ['aio_fixture_width'],
        },
        {
          title: '夹手1距边',
          keys: ['aio_first_fixture_height'],
        },
        {
          title: '夹手2距边',
          keys: ['aio_second_fixture_height'],
        },
        {
          title: '夹手方向',
          keys: ['aio_fixture_direction'],
        },
      ]
      let currentFlat = flatObj(current)
      let oriFlat = flatObj(ori)

      currentFlat = {
        ...currentFlat,
        yitiji_machine_name: currentFlat.aioOptions.find(
          (item) => item.value == currentFlat.yitiji_machine_name
        ).label,
      }
      oriFlat = {
        ...oriFlat,
        yitiji_machine_name: currentFlat.aioOptions.find(
          (item) => item.value == oriFlat.yitiji_machine_name
        ).label,
      }
      return {
        key: '一体机设置',
        dataArr: [
          {
            type: 'form',
            current: currentFlat,
            ori: oriFlat,
            compareMsg,
            formTextObj: AioMachineSettingTextObj,
            formValueObj: AioMachineSettingValueObj,
          },
          {
            type: 'table',
            list: currentFlat.knives ? Object.values(currentFlat.knives) : [],
            oriList: oriFlat.knives ? Object.values(oriFlat.knives) : [],
            keys: [
              'name',
              'diameter',
              'use',
              'moveZF',
              'cutZF',
              'moveF',
              'cutF',
              'xOffset',
              'yOffset',
              'zOffset',
              'startCode',
              'stopCode',
              'axis_offset',
              'arc_radius',
              'type',
            ],
            tableType: operateRecordTableType.MODEL_AIO_TABLE,
            key: '刀具',
          },
        ],
      }
    },
    // 比较锯切雕刻机
    compareSawEngraving(current, ori) {
      current = current || {}
      ori = ori || {}
      // 锯切雕刻机刀库
      const currentSawTableList = current.mentaoji_saws
        ? Object.values(current.mentaoji_saws)
        : []
      const oriSawTableList = ori.mentaoji_saws
        ? Object.values(ori.mentaoji_saws)
        : []
      const compareMsg = [
        {
          title: '',
          keys: ['mentaoji_enable'],
        },
        {
          title: '',
          keys: ['processType'],
        },
        {
          title: '锯片用途',
          keys: ['sawToTrim', 'sawToCut'],
        },
        {
          title: '',
          keys: ['noVerticalSaw'],
        },
        {
          title: '',
          keys: ['mentaojiSizeSetting', 'mentaojiSize'],
        },
        {
          title: '',
          keys: ['sawThrough', 'sawThroughSize'],
        },
        {
          title: '',
          keys: ['sawToLayout'],
        },
        {
          title: '已封好不再切的大板边',
          keys: ['edgeNoSaw', 'edgeNoSawSide'],
        },
        {
          title: '每张大板上只排相同宽度小板',
          keys: ['sameWidthPlank'],
        },
        {
          title: '切割时不生成空走路径',
          keys: ['noCutEmptyPath'],
        },
        {
          title: '焊接板才使用锯片加工',
          keys: ['sawCutOnlyWeld'],
        },
        {
          title: '',
          keys: ['minSurplusWidthDiff'],
        },
        {
          title: '',
          keys: ['sawBoardGap'],
        },
        {
          title: '反面截取余料',
          keys: ['backCutSurplus'],
        },
        {
          title: '',
          keys: ['firstCutSurplus'],
        },
        {
          title: '',
          keys: ['surplusStoreAndLabeling'],
        },
        {
          title: '',
          keys: [
            'surplusMinWidth',
            'surplusMinLength',
            'crossCutOnlyMinSurplusSize',
          ],
        },
        {
          title: '按板件长度依次排版',
          keys: ['sortByHeight'],
        },
        {
          title: '',
          keys: ['saw_aio_setting'],
        },
        {
          title: '',
          keys: ['sawReplace'],
        },
        // {
        //   title: '',
        //   keys: ['sawReplaceEnable'],
        // },
        // {
        //   title: '',
        //   keys: ['minSawLength'],
        // },
        // {
        //   title: '',
        //   keys: ['keepDistance'],
        // },
      ]
      return {
        key: '锯切雕刻机',
        dataArr: [
          {
            type: 'form',
            current,
            ori,
            compareMsg,
            formTextObj: SawEngravingTextObj,
            formValueObj: SawEngravingValueObj,
          },
          {
            type: 'table',
            list: currentSawTableList,
            oriList: oriSawTableList,
            keys:
              currentSawTableList.length > 0
                ? Object.keys(currentSawTableList[0])
                : oriSawTableList.length > 0
                ? Object.keys(oriSawTableList[0])
                : [],
            tableType: operateRecordTableType.MENTAOJI_SAW_TABLE,
            key: '刀库',
          },
        ],
      }
    },
    // 比较机械臂对接
    compareRobotArm(current, ori) {
      const compareMsg = [
        {
          title: '自动线对接设置',
          keys: [
            'auto_line_enable',
            'enable',
            'robotic_arm_model',
            'huahua_auto_line',
          ],
        },
      ]
      return {
        key: '自动线对接',
        dataArr: [
          {
            type: 'form',
            current,
            ori,
            compareMsg,
            formTextObj: RobotArmDockingTextObj,
            formValueObj: {},
          },
        ],
      }
    },
    // 比较激光一体机
    compareLaserCuttingMachine(current, ori) {
      // 处理反面刀库数据，将对象转换为数组
      // 确保每个项都有 webId，如果没有则使用 desc 作为临时标识
      const currentBackKnivesList = current.back_knives
        ? Object.values(current.back_knives).map((item) => ({
            ...item,
            [webId]: item[webId] || item.desc || genUniId(),
          }))
        : []
      const oriBackKnivesList = ori.back_knives
        ? Object.values(ori.back_knives).map((item) => ({
            ...item,
            [webId]: item[webId] || item.desc || genUniId(),
          }))
        : []

      const compareMsg = [
        {
          title: '启用激光一体机',
          keys: ['laser_enable'],
        },
        {
          title: '切割设置',
          keys: ['cut_setting'],
        },
        {
          title: '坐标轴',
          keys: ['coordinate_axis'],
        },
        {
          title: '正/反面激光刀设置',
          keys: ['laser_tool_settings'],
        },
      ]
      return {
        key: '激光一体机',
        dataArr: [
          {
            type: 'table',
            list: currentBackKnivesList,
            oriList: oriBackKnivesList,
            keys:
              currentBackKnivesList.length > 0
                ? Object.keys(currentBackKnivesList[0])
                : [],
            tableType: operateRecordTableType.LASER_CUTTING_MACHINE_TABLE,
            excludeKeys: ['millable'],
            idKey: webId,
            key: '反面刀库',
          },
          {
            type: 'form',
            current,
            ori,
            compareMsg,
            formTextObj: LaserCuttingMachineTextObj,
            formValueObj: LaserCuttingMachineValueObj,
          },
        ],
      }
    },
    judgeangleDeceleration(list) {
      let isAbleSave = true
      if (!list.length) {
        isAbleSave = false
      } else if (list.length == 1) {
        isAbleSave = list[0].every((item) => Number(item))
      } else {
        isAbleSave =
          list.flat(1).every((item) => Number(item)) &&
          list[0][0] < list[1][0] &&
          list[0][1] < list[1][1]
      }
      if (
        !this.$refs.cutting_params.formData.processingSpeedSetting
          .angle_deceleration_enabled
      ) {
        isAbleSave = true
      }
      if (!isAbleSave) {
        this.$message({
          message: this.$t('cuttingDock.slowDownSpeedTip'),
          type: 'error',
        })
      }
      return isAbleSave
    },
    saveDataJsonToOssForRecordFn(record, option, cb) {
      saveDataJsonToOssForRecord(record, 'equipment_docking', option, cb)
    },
    /**
     *
     * @param {*} current // 修改后的生产线设置
     * @param {*} ori // 上一次保存的生产线设置
     * @param {*} productionLineName // 当前生产线名
     */
    async genFinalRecordFn(
      current,
      ori,
      productionLineName,
      saveData,
      callback = null
    ) {
      this.reSetLabelPictureDelimiter(current, ori)
      const recordData = {
        productionLineName,
        key: '雕刻机', // 操作记录最外层的名字，比如：雕刻机
        operateArr: [
          // 应对多个操作页面时，比如雕刻机的操作页面
          this.compareCuttingDock(current.cutDockData, ori.knivesSetting),
          this.compareCuttingParams(current.cutParam, ori.cuttingSetting),
          this.compareLabellingSetting(
            current.labelingSetting,
            ori.labelingSetting
          ),
          this.compareGangDrill(current.drillingSetting, ori.drillingSetting),
          this.compareNcExportSetting(
            current.ncOutputSetting,
            ori.ncOutputSetting
          ),
          this.compareOneDragTwoEngraving(
            current.oneForTwoDeviceSetting,
            ori.oneForTwoDeviceSetting
          ),
          this.compareAioMachineSetting(
            current.integrationDeviceSetting,
            ori.integrationDeviceSetting
          ),
          this.compareSawEngraving(current.sawSetting, ori.sawSetting),
          this.compareRobotArm(
            current.robotic_arm_setting,
            ori.robotic_arm_setting
          ),
          this.compareLaserCuttingMachine(
            current.laser_setting,
            ori.laser_setting
          ),
        ],
      }
      try {
        const res = await genFinalRecordPromise(recordData, 'equipment_docking')
        if (res) {
          const { record, finalId, action_type } = res
          saveDataJsonToOssForRecord(
            record,
            action_type,
            {
              id: finalId,
              operate_equipment: 'engraving',
              save_data: saveData,
              setting_id: this.$route.query.setting_id,
              operatorPhone: this.previewInfo.operatorPhone,
            },
            () => {
              callback && callback()
              if (!this.previewInfo.isApply) {
                this.loadEngraving()
              }
            }
          )
        }
      } catch (error) {
        console.error('error', error)
        this.$message({
          message: '生成操作记录失败',
          type: 'error',
        })
      }
    },
    // 保存配置
    saveEngraving() {
      // 特殊孔槽规则 key 不能设置为空
      const isCanSave =
        this.$refs.cutting_params?.$refs.SpecialHoleAndSlotTable?.scrollToRowAndJudgeIsSave()
      if (isCanSave === false) {
        this.$message.warning(
          translateLang('cuttingDock.cuttingParams.specialRuleTip')
        )
        return
      }
      const isCanSave2 =
        this.$refs.cutting_params?.$refs.specialHoleSlotRef?.scrollToRowAndJudgeIsSave()
      if (isCanSave2 === false) {
        this.$message.warning('请选择孔类型或设置孔直径！')
        return
      }

      // 判断锁定状态，打开弹窗
      // 根据获取的状态 锁定状态
      this.lockStatus = this.tempStatus
      if (this.showTiangong) {
        this.$message({
          message: this.$t('cuttingDock.permissionErr'),
          type: 'info',
          duration: 1500,
          offset: 60,
        })
        return
      }
      const cutForm = this.$refs?.cutting_params?.formData
      if (!cutForm?.trimmingSetting.trimSideInBluenNcSettings) {
        modalMsg(
          this.$t('cuttingDock.firstSave'),
          'warning',
          this.$t('common.confirm'),
          this.saveFun
        )
        return
      } else {
        this.saveFun()
      }
    },
    // 打开修改记录弹窗
    handleOpenChangeRecord() {
      this.showRecordModal = true
    },
    handleNeedReductionSaveVerify() {
      this.isReductionSaveVerify = true
      this.showSaveModal(true)
    },
    // 保存处理数据
    saveFun() {
      this.$nextTick(async () => {
        // 二次加工权限过期时，仍存在收费工艺则禁止保存
        const canSavePaidProcess =
          await this.$refs.nc_export?.validateExpiredPaidProcessTypes?.()
        if (canSavePaidProcess === false) {
          this.nowPage = 'NcExportSetting'
          window.localStorage.setItem('engravingNav', this.nowPage)
          return
        }
        // 处理开料对接的数据
        const cutDockData = this.dealCuttingDockData()
        // 开料对接数据验证
        if (!cutDockData || !this.checkCuttingDockData(cutDockData)) {
          return
        }
        // 处理切割参数
        const isObliqueThickValid =
          this.$refs.cutting_params.validateObliqueThickRequiredForSave()
        if (!isObliqueThickValid) {
          this.nowPage = 'cuttingParams'
          window.localStorage.setItem('engravingNav', this.nowPage)
          this.$nextTick(() => {
            const dom = document.getElementById('optimize-speed')
            scrollToElementFn(dom)
          })
          return this.$message({
            message:
              this.$refs.cutting_params.getObliqueThickSaveErrorMessage(),
            type: 'warning',
          })
        }
        const cutParam = this.dealCuttingParamsData()
        if (!cutParam) {
          return
        }

        if (
          !this.$refs.labelling_setting.formData.labelFormat &&
          this.$refs.labelling_setting.formData.labelingMachine
        ) {
          this.$message({
            message: this.$t('cuttingDock.labellingTempErr'),
            type: 'error',
          })
          return
        }

        this.$refs.nc_export.dealNameArr()
        // 处理nc导出设置
        let ncExportData = this.dealNcExportSettingData()
        // 处理贴标设置
        let labellingSetting = this.dealLabellingSettingData()
        // 用户定制需求，开启贴标图片跟随贴标文件放在NC文件夹里后 不能使用标签图片根据大板分为不同文件夹
        if (
          ncExportData.folderCategory.label_image_in_nc_folder &&
          store.state.userPermissions['label_image_in_nc_folder']
        ) {
          labellingSetting = {
            ...labellingSetting,
            label_img_big_plank_folder: false,
          }
        }
        if (!labellingSetting) {
          return
        }
        // 检查是否可以保存
        const canSave = this.checkIsCanSaveSetting()
        if (!canSave) {
          if (
            this.$refs.nc_export.isContainsSpecialChars ||
            this.$refs.nc_export.isNullFileSide
          ) {
            this.nowPage = 'NcExportSetting'
          }
          if (
            !this.$refs.labelling_setting.formData.label_image_name_type.length
          ) {
            this.nowPage = 'labellingSetting'
          }
          window.localStorage.setItem('engravingNav', this.nowPage)
          this.$nextTick(() => {
            this.scrollToElement()
          })
          return
        }
        if (
          labellingSetting.rotateLabelSetting.rotateLabel &&
          !Number(labellingSetting.rotateLabelSetting.criticalValue)
        ) {
          this.$refs.labelling_setting.focusInput()
          return this.$message.error(this.$t('cuttingDock.autoRollInputTip'))
        }
        labellingSetting.rotateLabelSetting.criticalValue = Number(
          labellingSetting.rotateLabelSetting.criticalValue
        )
        // 一体机设置
        const aioMachineData = this.dealAioMachineData()
        if (!aioMachineData) return
        // 排钻设置数据
        const drillData = this.dealDrillData()
        // 一拖二数据
        const oneDragTwoData = this.dealOneDragTwoData()
        // 双面板修四边定位气缸方向处理 修边方向的对边
        let trimSide = cutParam.trimmingSetting.trimSide
        if (cutParam.trimmingSetting.is_double_panel_four_trim) {
          trimSide = trimSide.includes('Left')
            ? trimSide.replace(/Left/g, 'Right')
            : trimSide.replace(/Right/g, 'Left')
        }
        let oneTrimSide =
          oneDragTwoData.one_for_two_trimming_setting.one_for_two_trim_side
        if (
          oneDragTwoData.one_for_two_trimming_setting
            .one_for_two_is_double_panel_four_trim
        ) {
          oneTrimSide = oneTrimSide.includes('Left')
            ? oneTrimSide.replace(/Left/g, 'Right')
            : oneTrimSide.replace(/Right/g, 'Left')
        }
        // 获取到了切割参数和一拖二的数据，需要判断它们是否开启单面加工板生成正面修边路径且先修边，如果开启了，修边方向不能为空
        if (this.checkIsCanSaveSettingSingle(cutParam, oneDragTwoData)) {
          if (
            cutParam.trimmingSetting.is_first_trim_single_panel &&
            !cutParam.trimmingSetting.single_panel_trim_direction
          ) {
            this.nowPage = 'cuttingParams'
          } else if (
            oneDragTwoData.enableOneForTwoDevice &&
            oneDragTwoData.one_for_two_trimming_setting.one_for_two_trim &&
            oneDragTwoData.one_for_two_trimming_setting
              .one_for_two_single_panel_trim &&
            !oneDragTwoData.one_for_two_trimming_setting
              .one_for_two_single_panel_trim_direction
          ) {
            this.nowPage = 'oneDragTwoEngraving'
          }
          window.localStorage.setItem('engravingNav', this.nowPage)
          this.$nextTick(() => {
            let dom = document.getElementById(`singlePanelTrim_${this.nowPage}`)
            // dom.scrollIntoView({
            //   behavior: 'smooth',
            //   block: 'start',
            // })
            scrollToElementFn(dom)
          })
          return this.$message({
            message: '单面加工板正面生成修边路径且先修边方向不能为空！',
            type: 'warning',
          })
        }
        // 切割参数 加工速度优化-单独设置小板尺寸范围加工速度的数据验证
        if (this.checkIsCanSaveSettingCustomSpeed(cutParam)) {
          this.nowPage = 'cuttingParams'
          window.localStorage.setItem('engravingNav', this.nowPage)
          this.$nextTick(() => {
            let dom = document.getElementById('speed-rule')
            scrollToElementFn(dom)
          })
          return this.$message({
            message: this.$t('cuttingDock.cuttingParams.saveCustomSpeedTip'),
            type: 'warning',
          })
        }
        // 单独设置小板尺寸范围加工速度规则--添加规则埋点
        try {
          const speedRuleLength =
            cutParam.processingSpeedSetting.small_plank_cut_rule.length -
            this.oriAllData.cuttingSetting.processingSpeedSetting
              .small_plank_cut_rule.length
          if (speedRuleLength > 0) {
            // 执行次数是差值
            for (let i = 0; i < speedRuleLength; i++) {
              buryPointApi('engraving', 'small_plank_cut_rule')
            }
          }
        } catch (error) {
          console.log('埋点数据错误', error)
        }
        // 切割参数 开料分层切割的数据验证
        if (this.checkIsCanSaveSettingCutting(cutParam)) {
          this.nowPage = 'cuttingParams'
          window.localStorage.setItem('engravingNav', this.nowPage)
          this.$nextTick(() => {
            let dom = document.getElementById(
              'engraving_setting_plankTable_div'
            )
            scrollToElementFn(dom)
          })
          return this.$message({
            message:
              this.checkIsCanSaveSettingCutting(cutParam) == 'repeat'
                ? this.$t('cuttingDock.cuttingParams.saveLayeredRepeatTip')
                : this.$t('cuttingDock.cuttingParams.saveLayeredCuttingTip'),
            type: 'warning',
          })
        }
        // 指定板件名称二次切割开关开启且未添加板件名或存在板件名为空
        if (
          cutParam.longPlankCuttingSetting.specified_board_secondary_cutting
        ) {
          const condition1 =
            cutParam.longPlankCuttingSetting.secondary_cutting_board_list.filter(
              (item) => item.trim()
            ).length
          const condition2 =
            cutParam.longPlankCuttingSetting.secondary_cutting_board_list.some(
              (item) => !item.trim()
            )
          if (!condition1 || condition2) {
            this.$nextTick(() => {
              let dom = document.getElementById(
                'engraving_setting_add_plank_name_btn'
              )
              scrollToElementFn(dom)
            })
            return this.$message({
              message: condition2
                ? this.$translateLang('板件名不能为空，请输入') + '！'
                : this.$translateLang('请至少添加一个板件名') + '！',
              type: 'warning',
            })
          }
        }
        labellingSetting.layoutImageSetting.layoutImage.forEach(
          (item, index) => {
            item.way = index + 1
          }
        )
        // 是否可以保存 切割参数-分层切割-铣槽拉槽
        if (this.checkIsCanSaveSettingSlots(cutParam)) {
          // 存在部分数据不符合规范，滑动定位到有问题的地方
          this.nowPage = 'cuttingParams'
          window.localStorage.setItem('engravingNav', this.nowPage)
          // 定位不符合填写规范的元素
          let dom = document.getElementById('hierarchy-cutting')
          this.$nextTick(() => {
            scrollToElementFn(dom)
          })
          let message =
            Number(cutParam.layeredCuttingSetting.layered_slot_gt_slot_deep) <=
            Number(cutParam.layeredCuttingSetting.layered_slot_second_slot_deep)
              ? '当铣槽拉槽分层切割开启时，切割深度不能大于槽深度！'
              : '当拉槽铣槽分层切割开启时，填写数据不能为空！'
          return this.$message({
            message: message,
            type: 'warning',
          })
        }
        // 锯切雕刻机设置
        const sawSetting = this.$refs.sawEngraving.formData
        sawSetting.mentaoji_saws.forEach((item) => {
          item.x_offset = item.x_offset.toString()
          item.y_offset = item.y_offset.toString()
        })
        // 机械臂对接设置（自动线对接与锯切雕刻机共用同一份数据）
        const robotic_arm_setting = this.$refs.robotArmDocking.formData
        if (
          robotic_arm_setting.enable &&
          !robotic_arm_setting.robotic_arm_model
        ) {
          return this.$message({
            message: '机械臂对接生成文件类型不能为空，请选择！',
            type: 'warning',
          })
        }

        // 应急码设置不能重复
        const ncExportSetting = this.$refs.nc_export.formData
        const emergencySetting = ncExportSetting.emergencySetting
        const emergencyValues = Array.isArray(emergencySetting)
          ? emergencySetting.map((item) => item.settingKey)
          : []
        if (
          emergencyValues.length > 0 &&
          emergencyValues.length !== new Set(emergencyValues).size
        ) {
          return this.$message({
            message: '应急码不能重复！',
            type: 'warning',
          })
        }

        // 单独文件加工：孔/槽生效范围不能为空
        const singleFileSetting = ncExportSetting.singleFileSetting
        if (singleFileSetting?.enable) {
          const processTypes = singleFileSetting.processTypes || []
          const isEmptyValue = (val) =>
            val === '' || val === undefined || val === null
          if (processTypes.includes('hole')) {
            const holeRange = singleFileSetting.holeRange || []
            const hasEmptyHoleRange =
              !holeRange.length ||
              holeRange.some((item) => isEmptyValue(item?.value))
            if (hasEmptyHoleRange) {
              this.$nextTick(() => {
                const dom = document.getElementById('singleFileSetting')
                if (dom) scrollToElementFn(dom)
              })
              return this.$message({
                message: this.$translateLang('孔生效范围不能为空，请填写！'),
                type: 'warning',
              })
            }
          }
          if (processTypes.includes('slot')) {
            const slotRange = singleFileSetting.slotRange || []
            const hasEmptySlotRange =
              !slotRange.length ||
              slotRange.some(
                (item) =>
                  isEmptyValue(item?.slot_length?.value) ||
                  isEmptyValue(item?.slot_width?.value)
              )
            if (hasEmptySlotRange) {
              this.$nextTick(() => {
                const dom = document.getElementById('singleFileSetting')
                if (dom) scrollToElementFn(dom)
              })
              return this.$message({
                message: this.$translateLang('槽生效范围不能为空，请填写！'),
                type: 'warning',
              })
            }
          }
        }

        // 处理激光一体机数据
        const laserSetting = this.dealLaserCuttingMachineData()

        // 激光反面刀库
        const laserKnives = Object.values(laserSetting.back_knives)
        // 开料刀库
        const cutDockDataKnives = Object.values(cutDockData.knives)

        // 选择开料刀切换为激光刀取消勾选开料且置灰 再切换成其他刀
        if (
          cutDockDataKnives.length &&
          cutDockDataKnives.every((item) => item.cutable === false)
        ) {
          return message.warning(
            this.$translateLang('开料对接') +
              this.$translateLang(
                '刀库中请勾选“开料”选项的刀具，不然无法加工内部未切透异形'
              )
          )
        }

        if (laserSetting.laser_enable) {
          if (
            laserKnives.length &&
            laserKnives.every((key) => key.cutable === false)
          ) {
            return message.warning(
              this.$translateLang('激光一体机') +
                this.$translateLang(
                  '刀库中请勾选“开料”选项的刀具，不然无法加工内部未切透异形'
                )
            )
          }
          // 开料机和激光机保存时候 需要核对激光刀以及其刀径是否相同，不同给出提示且不保存
          const laserKnife = laserKnives.find((key) => key.type === 'laser')
          const millKnife = cutDockDataKnives.find(
            (item) => item.type === 'laser'
          )
          const getDiameterValue = (diameter) => {
            return diameter != null && diameter !== '' ? Number(diameter) : null
          }
          if (laserKnife && millKnife) {
            // 确保有刀再做刀径判断
            const laserDiameter = getDiameterValue(laserKnife.diameter)
            const millDiameter = getDiameterValue(millKnife.diameter)
            if (laserDiameter !== millDiameter) {
              return message.warning(
                this.$translateLang(
                  '开料刀库激光刀径和激光一体机激光刀径不一致，请检查'
                )
              )
            }
          }
          // 开料机和激光机保存时候 需要核对下料刀及其刀径是否相同，不同给出提示且不保存
          const cutableMillKnife = cutDockDataKnives.find(
            (item) => item.cutable === true
          )
          const cutableMillKnifeForLaser = laserKnives.find(
            (item) => item.cutable === true
          )
          if (cutableMillKnife && cutableMillKnifeForLaser) {
            const cutableMillKnifeDiameter = getDiameterValue(
              cutableMillKnife.diameter
            )
            const cutableMillKnifeForLaserDiameter = getDiameterValue(
              cutableMillKnifeForLaser.diameter
            )
            if (cutableMillKnifeDiameter !== cutableMillKnifeForLaserDiameter) {
              return message.warning(
                this.$translateLang(
                  '开料刀库下料刀径和激光一体机下料刀径不一致，请检查'
                )
              )
            }
          }
        }
        // 暂时用不到 后续待产品考虑是否添加
        //  else {
        //   //  关闭的时候需要查看开料是否有激光刀 且 全都不勾选开料，若有要改为铣刀
        //   if (cutDockDataKnives.every((item) => item.cutable === false)) {
        //     // 当所有刀都不勾选开料 那么就必定会有一把激光刀(只有将开料的刀切换成激光刀才会出现这种情况，其他场景都会确保有且仅有一把刀开料)
        //     // 需要将激光刀改为铣刀
        //     Object.keys(cutDockData.knives).forEach((key) => {
        //       const item = cutDockData.knives[key]
        //       if (item.type === 'laser') {
        //         item.type = 'mill'
        //         item.cutable = true
        //         cutDockData.knives[key] = item
        //         this.allData.knivesSetting.knives = cutDockData.knives
        //       }
        //     })
        //   }
        // }
        const obj = {
          knivesSetting: cutDockData,
          cuttingSetting: {
            ...cutParam,
            trimmingSetting: { ...cutParam.trimmingSetting, trimSide },
          },
          labelingSetting: labellingSetting,
          drillingSetting: drillData,
          ncOutputSetting: ncExportData,
          integrationDeviceSetting: aioMachineData,
          oneForTwoDeviceSetting: {
            ...oneDragTwoData,
            one_for_two_trimming_setting: {
              ...oneDragTwoData.one_for_two_trimming_setting,
              one_for_two_trim_side: oneTrimSide,
            },
          },
          sawSetting,
          robotic_arm_setting,
          laser_setting: laserSetting,
        }
        let data = JSON.stringify({
          data: obj,
          setting_id: this.$route.query.setting_id,
          ...store.state.saveInfo,
          platform: 'bluen',
        })
        this.ableSaveSetting = false
        this.$store.commit('setCurrentProductLineName', this.$route.query.line)
        this.$token('/save_engraving_setting', data, async (res) => {
          this.ableSaveSetting = true
          if (res.status === 1) {
            // 保存成功后，工位1，2双面加工正面注释代码增加埋点（修改次数）
            this.handleAddAnnotationCodeBuryPoint(cutDockData, this.oriAllData)
            // xy基准对调埋点处理
            this.handleAddXYSwapBuryPoint(cutParam, this.oriAllData)
            // 处理开启功能的埋点
            this.dealTurnOnFunctionBury(
              cutParam,
              this.oriAllData.cuttingSetting,
              'cuttingPunchingSetting'
            )
            // 处理激光一体机功能埋点
            this.dealLaserCuttingMachineBury(laserSetting)
            // 生成最终的操作记录
            try {
              await this.genFinalRecordFn(
                {
                  cutDockData,
                  cutParam,
                  labelingSetting: labellingSetting,
                  drillingSetting: drillData,
                  ncOutputSetting: ncExportData,
                  integrationDeviceSetting: aioMachineData,
                  oneForTwoDeviceSetting: oneDragTwoData,
                  sawSetting,
                  robotic_arm_setting,
                  laser_setting: laserSetting,
                },
                this.oriAllData,
                this.$route.query.line,
                obj
              )
            } catch (error) {
              console.error('error', error)
            }
            // 贴标图片名-各项数据埋点
            labellingSetting.label_image_name_type.forEach((item) => {
              buryPointApi('engraving', `label_image_name_type_${item}`)
            })
            // PDF文件名-各项数据埋点
            labellingSetting.pdf_label_name.forEach((item) => {
              buryPointApi('engraving', `pdf_label_name_${item}`)
            })
            this.isShowVisible = false
            if (res.data.phone && res.data.request_ip) {
              let recordData = {
                key: '保存设置',
                operateArr: [
                  {
                    key: '生产线设置',
                    dataArr: [
                      {
                        type: 'form',
                        current: {
                          phone: res.data.phone,
                          time: new Date().toLocaleString(),
                          id: store.state.userInfo.id,
                          ip: res.data.request_ip,
                        },
                        ori: {
                          phone: '',
                          time: '',
                          id: '',
                          ip: '',
                        },
                        compareMsg: [
                          {
                            title: '',
                            keys: ['phone', 'time', 'id', 'ip'],
                          },
                        ],
                        formTextObj: {
                          phone: '手机号',
                          time: '保存时间',
                          id: '用户id',
                          ip: '物理地址',
                        },
                        formValueObj: {},
                      },
                    ],
                  },
                ],
              }
              genFinalRecord(recordData, 'equipment_docking', '', () => {})
            }
            this.$message({
              type: 'success',
              message: this.$t('common.saveSuccess'),
              duration: 1500,
              offset: 70,
            })
            // 由于在保存成功后，没有重新去获取数据，所以需要手动更新原始数据（建议调用接口，重新获取数据）
            this.oriAllData = JSON.parse(JSON.stringify(obj))
            this.allData.cuttingSetting = JSON.parse(
              JSON.stringify(obj.cuttingSetting)
            )
            // 如果保存成功用户修改了贴标起始值直接去贴标管理页数据
            if (
              this.ncSetting.process_setting_id ||
              this.$route.query.setting_id == this.ncSetting.process_setting_id
            ) {
              // 更新贴标起始值
              this.$store.commit(
                'setFrontLabelingStartNum',
                labellingSetting.front_labeling_start_num
              )
            }
          } else if (res.status == -1) {
            if (store.state.saveInfo.phone) {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: 1500,
                offset: 70,
              })
            }
            this.showSaveModal()
          } else {
            this.$message({
              type: 'error',
              message: res?.msg || this.$t('lineManager.permissionTip'),
              duration: 1500,
              offset: 70,
            })
          }
          store.commit('setSaveInfo', {})
        })
      })
    },
    // 切割参数-加工速度优化-单独设置小板尺寸范围加工速度
    checkIsCanSaveSettingCustomSpeed(cutParam) {
      if (cutParam.processingSpeedSetting.small_plank_cut_switch) {
        return !cutParam.processingSpeedSetting.small_plank_cut_rule.every(
          (item) => item.speed
        )
      }
      return false
    },
    // 开料对接数据验证
    checkCuttingDockData(cutDockData) {
      // 代码框使用了大板厚度标识标签时，校验付费权限
      if (
        this.hasUsedThickMarkLabel(cutDockData) &&
        checkUserPermissions([USER_PERMISSION_KEY.BIG_PLANK_THICK_MARK]) !==
          true
      ) {
        message.info(
          this.$translateLang('您当前无大板厚度标识权限，请联系销售购买后使用')
        )
        return false
      }
      // 检测刀库中的刀具长度是否大于开料对接中的单次最大加工深度
      const { knives } = cutDockData
      let errKey = ''
      const hasErr = Object.entries(knives).some(([key, knife]) => {
        const { length, maximum_single_depth } = knife
        if (maximum_single_depth > length) {
          errKey = key
          return true
        }
      })
      if (errKey) {
        message.error(
          this.$translateLang(
            `刀库{errKey}刀中单次最大加工深度不能大于刀具长度`,
            {
              errKey,
            }
          )
        )
      }
      return !hasErr
    },
    // 开料对接代码框是否使用了大板厚度标识标签
    hasUsedThickMarkLabel(cutDockData) {
      const thickMarkToken = '{大板厚度标识}'
      return Object.values(cutDockData).some((item) => {
        return (
          item &&
          typeof item === 'object' &&
          typeof item.template_string === 'string' &&
          item.template_string.includes(thickMarkToken)
        )
      })
    },
    // 检测是否可以保存 切割参数-分层切割-铣槽拉槽
    checkIsCanSaveSettingSlots(cutParam) {
      return (
        (cutParam.layeredCuttingSetting.layered_slot_cutting &&
          (!cutParam.layeredCuttingSetting.layered_slot_lt_knife_diameter ||
            !cutParam.layeredCuttingSetting.layered_slot_gt_slot_deep ||
            !cutParam.layeredCuttingSetting.layered_slot_second_slot_deep)) ||
        (cutParam.layeredCuttingSetting.layered_slot_cutting &&
          Number(cutParam.layeredCuttingSetting.layered_slot_gt_slot_deep) <=
            Number(
              cutParam.layeredCuttingSetting.layered_slot_second_slot_deep
            ))
      )
    },
    // 切割参数-开料分层切割
    checkIsCanSaveSettingCutting(cutParam) {
      // cutParam.layeredThickSetting.layeredThicks
      // 当开关是关闭状态
      if (!cutParam.layeredThickSetting.isLayeredCut) return
      const compareStringList = []
      for (
        let i = 0;
        i < cutParam.layeredThickSetting.layeredThicks.length;
        i++
      ) {
        let { matCode, highlight, pThick } =
          cutParam.layeredThickSetting.layeredThicks[i]
        let item = cutParam.layeredThickSetting.layeredThicks[i]
        if (!matCode) {
          matCode = ''
        }
        let key = `${pThick}_${highlight}_${matCode}`
        // 如果能在数组中找到数据，结束循环
        if (compareStringList.includes(key)) return 'repeat'
        compareStringList.push(key)
        if (
          Math.abs(
            Number(item['pThick']) -
              (Number(item['firstCut']) +
                Number(item['secondCut']) +
                Number(item['thirdCut']))
          ) > Number.EPSILON
        )
          return 'verify'
      }
    },
    showSaveModal(isReductionSaveVerify = false) {
      this.isReductionSaveVerify = isReductionSaveVerify
      this.lockStatus = this.tempStatus
      this.verifyPassword = true
      this.isShowVisible = true
      return
    },
    // 排钻设置数据处理
    dealDrillData() {
      const gangDrill = this.$refs['gang_drill']
      let formData = { ...gangDrill.formData }
      const drillTable = gangDrill.drillTableData
      const mainDrill = drillTable.find((e) => e.name === '主孔')
      formData.gangDrillCombinationEnable = gangDrill.isDriliingChecked
      // 主孔前缀
      formData.gangDrillCombinationMainPrefix = {
        label_ids: mainDrill?.knifePrefix?.label_ids || {},
        template_string:
          mainDrill?.knifePrefix?.template_string || mainDrill.prefix,
      }
      // 主孔后缀
      formData.gangDrillCombinationMainSuffix = {
        label_ids: mainDrill?.knifeSuffix?.label_ids || {},
        template_string:
          mainDrill?.knifeSuffix?.template_string || mainDrill.suffix,
      }
      // 从孔列表
      formData.gangDrillCombinationAuxiliaryList = drillTable
        .filter((e) => e.name.includes('从孔'))
        .map((e) => ({
          webId: e.webId,
          name: e.name,
          knifePrefix: {
            label_ids: e.knifePrefix?.label_ids || {},
            template_string: e.prefix,
          },
          knifeSuffix: {
            label_ids: e.knifeSuffix?.label_ids || {},
            template_string: e.suffix,
          },
        }))
      // 组合注释
      const combinedAnnotation = drillTable.find((e) => e.name === '组合注释')
      formData.gangDrillCombinationComment = {
        label_ids: combinedAnnotation?.knifePrefix?.label_ids || {},
        template_string:
          combinedAnnotation?.knifePrefix?.template_string ||
          combinedAnnotation.prefix,
      }
      // 首次启用注释
      const firstEnabledAnnotations = drillTable.find(
        (e) => e.name === '首次启用注释'
      )
      formData.gangDrillCombinationuCommentFirstSign = {
        label_ids: firstEnabledAnnotations?.knifePrefix?.label_ids || {},
        template_string:
          firstEnabledAnnotations?.knifePrefix?.template_string ||
          firstEnabledAnnotations.prefix,
      }
      return formData
    },
    // 切换导航栏
    async changeNav(item) {
      item =
        typeof item === 'string'
          ? this.navList.find((e) => e.val === item)
          : item
      if (item.val === 'sawEngraving') {
        const enable = await this.enableEngravingPermission(
          'sawSetting',
          'mentaoji_enable',
          'saw'
        )
        if (!enable) {
          this.$message({
            type: 'info',
            message: this.$translateLang(
              '没有锯切雕刻机使用权限，请联系销售购买全铝锯切补充包后使用'
            ),
            duration: 1500,
            offset: 70,
          })
          return
        }
      }
      if (item.val === 'laserCuttingMachine') {
        if (!this.isLaserPermission) {
          this.$message({
            type: 'info',
            message: this.$translateLang(
              '没有激光一体机使用权限，请联系销售购买激光一体机使用权限后使用'
            ),
            duration: 1500,
            offset: 70,
          })
          return
        }
      }
      if (item.val === 'robotArmDocking') {
        const enable = await this.enableEngravingPermission(
          'robotic_arm_setting',
          'auto_line_enable',
          'robotic_arm'
        )
        if (!enable) {
          this.$message({
            type: 'info',
            message: this.$translateLang(
              '您没有自动线使用权限或者能开启的自动线数量不足'
            ),
            duration: 1500,
            offset: 70,
          })
          return
        }
      }
      // if (item.val === 'labellingSetting' && !thirdPermission('/labeling'))
      //   return
      // 权限校验
      const authNavs = ['aioMachineSetting'] // 'labellingSetting'
      // 设备是否开启的key值
      const machineKey = {
        aioMachineSetting: 'enable_integration_device',
        // labellingSetting: 'labelingMachine',
      }
      // 判断账号版本
      if (authNavs.includes(item.val)) {
        try {
          // 获取当前设置
          const machineObj = {
            aioMachineSetting: 'integrationDeviceSetting',
            // labellingSetting: 'labelingSetting',
          }
          const machineName = {
            aioMachineSetting: 'integration',
            // labellingSetting: 'labeling',
          }
          const machineEquipment = {
            aioMachineSetting: '一体机',
            // labellingSetting: '贴标机',
            sawEngraving: '锯切雕刻机',
          }
          const enable = await this.enableEngravingPermission(
            machineObj[item.val],
            machineKey[item.val],
            machineName[item.val]
          )
          if (!enable) {
            this.$message({
              type: 'info',
              message: `您当前可使用的${
                machineEquipment[item.val]
              }生产线条数已用完，如需增加，请联系销售人员`,
              duration: 1500,
              offset: 70,
            })

            return
          }
        } catch (error) {
          // 打印错误
          this.$message({
            type: 'info',
            message: this.$translateLang('获取设备权限失败！'),
            duration: 1500,
            offset: 70,
          })
          console.log(error, 'error')
          return
        }
      }
      this.nowPage = item.val
      window.localStorage.setItem('engravingNav', this.nowPage)
    },
    // 为数据添加所需要的id
    addIdToNeedDataForAllData(allData) {
      // 为设备对接-门套机-开料对接-门套机列表 添加唯一id
      // addIdForItems(Object.values(allData.knivesSetting.mentaoji_saws))
      addIdForItems(allData.sawSetting.mentaoji_saws)
      // 为设备对接-雕刻机-开料对接-刀库列表 添加唯一id
      addIdForItems(Object.values(allData.knivesSetting.knives))
      // 为设备对接-雕刻机-开料对接-大板厚度标识 添加唯一id
      if (
        Array.isArray(allData.knivesSetting.big_plank_thickness_marking_range)
      ) {
        addIdForItems(allData.knivesSetting.big_plank_thickness_marking_range)
      }
      // 为设备对接-雕刻机-切割参数-板件列表 添加唯一id
      addIdForItems(allData.cuttingSetting.layeredThickSetting.layeredThicks)
      // 为设备对接-雕刻机-贴标设置-排版图设置 添加唯一id
      addIdForItems(allData.labelingSetting.layoutImageSetting.layoutImage)
      // 为设备对接-雕刻机-排钻设置-刀具 添加唯一id
      addIdForItems(allData.drillingSetting.drills)
      // 为设备对接-雕刻机-排钻设置-排钻组合下刀-从孔 添加唯一id
      addIdForItems(allData.drillingSetting.gangDrillCombinationAuxiliaryList)
      // 为设备对接-雕刻机-NC导出设置-应急设置 添加唯一id
      addIdForItems(allData.ncOutputSetting.emergencySetting)
      // 为设备对接-雕刻机-NC导出设置-孔/槽生效范围 添加唯一id
      addIdForItems(allData.ncOutputSetting?.singleFileSetting?.holeRange)
      addIdForItems(allData.ncOutputSetting?.singleFileSetting?.slotRange)
      // 为设备对接-雕刻机-激光一体机-反面刀库 添加唯一id
      addIdForItems(Object.values(allData.laser_setting.back_knives))
      // 为设备对接-雕刻机-切割参数-边缘槽隔条防断规则 添加唯一id
      const preventBreakageRules =
        allData.cuttingSetting?.cuttingPunchingSetting?.prevent_breakage_setting
          ?.rules
      if (Array.isArray(preventBreakageRules)) {
        addIdForItems(preventBreakageRules)
      }
    },
    // 读取配置
    loadEngraving() {
      this.$getByToken(
        '/labeling_list',
        {
          from: 'user',
        },
        (result) => {
          if (result.status == 1) {
            this.ableSaveSetting = false
            this.getEngravingSetting(result)
          }
        }
      )
    },
    // 重置 label_picture_delimiter
    reSetLabelPictureDelimiter(data, ori) {
      // 后端数据为字符串，需要用checkbox 需要转换为boolean类型
      if (data.labelingSetting.label_picture_delimiter == 'underline') {
        data.labelingSetting.label_picture_delimiter = false
      } else if (data.labelingSetting.label_picture_delimiter == 'none') {
        data.labelingSetting.label_picture_delimiter = true
      }
      // 特殊孔槽加工面自定义规则特殊处理
      if (data.cutParam) {
        data.cutParam.holeFaceSetting.isSpecialHoleSlot =
          data.cutParam.holeFaceSetting.custom_special_hole_slot_side.is_open
      }
      if (ori) {
        ori.cuttingSetting.holeFaceSetting.isSpecialHoleSlot =
          ori.cuttingSetting.holeFaceSetting.custom_special_hole_slot_side.is_open
      }

      if (data.cutParam) {
        data.cutParam.cuttingPunchingSetting.isSpecialThroughTwoSideToCut =
          data.cutParam.cuttingPunchingSetting.non_through_slot_two_side_cut.is_open
      }
      if (ori) {
        ori.cuttingSetting.cuttingPunchingSetting.isSpecialThroughTwoSideToCut =
          ori.cuttingSetting.cuttingPunchingSetting.non_through_slot_two_side_cut.is_open
      }
    },
    scrollToElement() {
      const engravingNav = localStorage.getItem('engravingNav')
      const scrollToElementMap = {
        NcExportSetting: {
          domFileNameType: 'ncExportSetting_fileNameType_input',
          domFileSide: 'engraving_setting_exportSetting_head_side',
        },
        labellingSetting: {
          domLabelImage: 'labelling_setting_labelImageName',
          domTagRotateOffset: 'labelling_setting_tagRotateOffset_switch',
        },
      }
      const isNcExportSetting = engravingNav === 'NcExportSetting'
      const isLabellingSetting = engravingNav === 'labellingSetting'
      const ncExportDomFileNameType = document.getElementById(
        scrollToElementMap[engravingNav].domFileNameType
      )
      const ncExportDomFileSide = document.getElementById(
        scrollToElementMap[engravingNav].domFileSide
      )
      const labellingSettingDom = document.getElementById(
        scrollToElementMap[engravingNav].domLabelImage
      )
      const tagRotateOffsetDom = document.getElementById(
        scrollToElementMap[engravingNav].domTagRotateOffset
      )

      if (isNcExportSetting) {
        if (this.$refs.nc_export.isContainsSpecialChars) {
          scrollToElementFn(ncExportDomFileNameType)
        }
        if (this.$refs.nc_export.isNullFileSide) {
          scrollToElementFn(ncExportDomFileSide)
        }
      }

      if (
        isLabellingSetting &&
        !this.$refs.labelling_setting.formData.label_image_name_type.length
      ) {
        scrollToElementFn(labellingSettingDom)
      }
      const changeTagRotateOffset =
        this.$refs.labelling_setting.formData.offsetAfterLabelRotation &&
        (!this.$refs.labelling_setting.formData.xOffsetAfterLabelRotation ||
          !this.$refs.labelling_setting.formData.yOoffsetAfterLabelRotation)
      if (isLabellingSetting && changeTagRotateOffset) {
        scrollToElementFn(tagRotateOffsetDom)
      }
    },
    handleGetLockStatus() {
      //TODO 进入页面，获取生产线设置锁的状态
      getLockStatus().then((res) => {
        // 拿到的锁状态赋值，当前是锁定还是解锁状态
        this.lockStatus = res?.data?.is_lock || 0
        this.tempStatus = res?.data?.is_lock || 0
      })
    },
    // 工位1，2双面正面加工注释代码埋点
    handleAddAnnotationCodeBuryPoint(data, oriData) {
      const { first_front_annotation_code, second_front_annotation_code } = data
      const {
        first_front_annotation_code: ori_first_front_annotation_code,
        second_front_annotation_code: ori_second_front_annotation_code,
      } = oriData.knivesSetting
      if (first_front_annotation_code !== ori_first_front_annotation_code) {
        // TODO: 增加工位1修改次数埋点
        buryPointApi(
          'equipment_dock',
          'engraving_first_front_annotation_code_change'
        )
      }
      if (second_front_annotation_code !== ori_second_front_annotation_code) {
        // TODO: 增加工位2修改次数埋点
        buryPointApi(
          'equipment_dock',
          'engraving_second_front_annotation_code_change'
        )
      }
    },
    // 大板反面xy基准互调埋点
    handleAddXYSwapBuryPoint(data, oriData) {
      const { x_reverse_reference_swap, y_reverse_reference_swap } =
        data.countertopSetting
      const {
        x_reverse_reference_swap: ori_X_reverse_reference_swap,
        y_reverse_reference_swap: ori_Y_reverse_reference_swap,
      } = oriData.cuttingSetting.countertopSetting
      if (x_reverse_reference_swap !== ori_X_reverse_reference_swap) {
        buryPointApi('equipment_dock', 'x_reverse_reference_swap')
      }
      if (y_reverse_reference_swap !== ori_Y_reverse_reference_swap) {
        buryPointApi('equipment_dock', 'y_reverse_reference_swap')
      }
    },
    dealTurnOnFunctionBury(data, oriData, firstLevelKey) {
      const booleanFunctionKeyList = ['z_shape_processed_through_slot']
      const objMap = firstLevelKey ? data[firstLevelKey] : data
      const oriObjMap = firstLevelKey ? oriData[firstLevelKey] : oriData
      booleanFunctionKeyList.forEach((key) => {
        if (objMap[key] && objMap[key] !== oriObjMap[key]) {
          buryPointApi('equipment_dock', key)
        }
      })
    },
    dealLaserCuttingMachineBury(data) {
      const { laser_enable } = data
      if (laser_enable) {
        buryPointApi('engraving', 'laser_setting_laser_enable')
      }
    },
    // 还原、重置参数成功后的回调
    async handleSuccess(data) {
      const {
        cuttingSetting: cutParam,
        drillingSetting: drillData,
        integrationDeviceSetting: aioMachineData,
        knivesSetting: cutDockData,
        labelingSetting: labellingSetting,
        ncOutputSetting: ncExportData,
        oneForTwoDeviceSetting: oneDragTwoData,
        sawSetting,
        robotic_arm_setting,
        laser_setting,
      } = data
      const obj = {
        knivesSetting: cutDockData,
        cuttingSetting: cutParam,
        labelingSetting: labellingSetting,
        drillingSetting: drillData,
        ncOutputSetting: ncExportData,
        integrationDeviceSetting: aioMachineData,
        oneForTwoDeviceSetting: oneDragTwoData,
        sawSetting,
        robotic_arm_setting,
        laser_setting,
      }
      // 生成最终的操作记录
      try {
        await this.genFinalRecordFn(
          {
            cutDockData,
            cutParam,
            labelingSetting: labellingSetting,
            drillingSetting: drillData,
            ncOutputSetting: ncExportData,
            integrationDeviceSetting: aioMachineData,
            oneForTwoDeviceSetting: oneDragTwoData,
            sawSetting,
            robotic_arm_setting,
            laser_setting,
          },
          this.oriAllData,
          this.$route.query.line,
          data,
          () => {
            // 生产记录成功后,重新回去操作记录数据
            this.$refs['recordModalRef']?.getData({ isReset: true })
          }
        )
      } catch (error) {}
      // 由于在保存成功后，没有重新去获取数据，所以需要手动更新原始数据（建议调用接口，重新获取数据）
      this.oriAllData = JSON.parse(JSON.stringify(obj))
      // 如果保存成功用户修改了贴标起始值直接去贴标管理页数据
      if (
        this.ncSetting.process_setting_id ||
        this.$route.query.setting_id == this.ncSetting.process_setting_id
      ) {
        // 更新贴标起始值
        this.$store.commit(
          'setFrontLabelingStartNum',
          labellingSetting.front_labeling_start_num
        )
      }
    },

    // 初始化雕刻机设置
    initEngravingMachineSetting(res) {
      this.ableSaveSetting = true
      let data = this.allLabelingList.find(
        (v) => v.labelFormat == res.data.labelingSetting.labelFormat
      )
      if (!data) {
        this.labelNotOnline = true
        this.$message({
          message: this.$t('cuttingDock.offlineTempFormat'),
          type: 'info',
        })
        res.data.labelingSetting.labelFormat = ''
      }
      this.reSetLabelPictureDelimiter(res.data)
      // 获取激光一体机是否开启
      this.isLaserEnable = res.data.laser_setting.laser_enable
      this.allData = res.data
      const labelImageInNcFolder =
        res.data.ncOutputSetting?.folderCategory?.label_image_in_nc_folder
      if (
        labelImageInNcFolder &&
        store.state.userPermissions['label_image_in_nc_folder']
      ) {
        this.allData.labelingSetting = {
          ...this.allData.labelingSetting,
          label_image_in_nc_folder: labelImageInNcFolder,
        }
      }
      // 兼容切割转角速度
      if (
        !this.allData.cuttingSetting.processingSpeedSetting
          .angle_deceleration_list
      ) {
        this.allData.cuttingSetting.processingSpeedSetting.angle_deceleration_list =
          [
            [
              this.allData.cuttingSetting.processingSpeedSetting
                .angle_deceleration_dis,
              this.allData.cuttingSetting.processingSpeedSetting
                .angle_deceleration_speed,
            ],
          ]
      }
      // 双面板修四边定位气缸方向处理 修边方向的对边
      if (
        this.allData.cuttingSetting.trimmingSetting.is_double_panel_four_trim
      ) {
        const trimSide = this.allData.cuttingSetting.trimmingSetting.trimSide
        this.allData.cuttingSetting.trimmingSetting.trimSide =
          trimSide.includes('Left')
            ? trimSide.replace(/Left/g, 'Right')
            : trimSide.replace(/Right/g, 'Left')
      }
      if (
        this.allData.oneForTwoDeviceSetting.one_for_two_trimming_setting
          .one_for_two_is_double_panel_four_trim
      ) {
        const trimSide =
          this.allData.oneForTwoDeviceSetting.one_for_two_trimming_setting
            .one_for_two_trim_side
        this.allData.oneForTwoDeviceSetting.one_for_two_trimming_setting.one_for_two_trim_side =
          trimSide.includes('Left')
            ? trimSide.replace(/Left/g, 'Right')
            : trimSide.replace(/Right/g, 'Left')
      }
      this.addIdToNeedDataForAllData(this.allData)
    },
    // 获取雕刻机设置
    getEngravingSetting(result) {
      this.ableSaveSetting = true
      this.allLabelingList = result.data.model_list
      this.$token(
        '/load_engraving_setting',
        {
          setting_id: this.$route.query.setting_id,
        },
        (res) => {
          if (res.status == 1) {
            this.initEngravingMachineSetting(res)
            // 设置原始值
            this.setOriginEngravingSetting(this.allData)
            if (this.previewProductLine?.engraving) {
              this.initEngravingMachineSetting({
                data: this.previewProductLine?.engraving,
              })
            }

            if (this.$route.query.tab === 'saw') {
              const sawRef = this.$refs.sawEngraving
              if (sawRef) {
                // 滚动到底部
                sawRef.scrollToBottom()
              }
            }
          } else {
            this.ableSaveSetting = false
          }
        }
      )
    },
    // 设置雕刻机原始设置
    setOriginEngravingSetting(data) {
      this.oriAllData = JSON.parse(JSON.stringify(data))
    },
    /**
     * 偏好设置更新
     */
    updatePreference({ data, isErr }) {
      if (isErr) return
      data = data || this.$store.state.preferencesSetting.setting
      this.isShowSecondaryCatalog = data.engravSwitchCloseAlwaysShow ?? true
    },
    // 获取设备使用权限
    async enableEngravingPermission(machineSetting, machineKey, machineName) {
      const machine_enable =
        this.allData?.[machineSetting]?.[machineKey] || false
      let { edition_id } = store.state.userInfo
      const res = await getEquipmentPermission({
        process_id: this.$route.query.setting_id,
        machine: machineName,
        edition_id: edition_id,
        use_machine: machine_enable ? 1 : 0,
      })
      if (res.status === 1) {
        return Boolean(res.data.can_use_num)
      }
      return false
    },
    // 获取刀具类型
    handleKnifeType() {
      this.$getByToken('/knife_type', {}, (res) => {
        if (res.status === 1) {
          this.knifeTypeOptions = res.data
            .filter((item) => {
              if (!this.isLaserPermission && item.name_key === 'laser') {
                return false
              }
              return true
            })
            .map((item) => ({
              label: item.name,
              value: item.name_key,
              isDisabled: false,
            }))
        } else {
          this.knifeTypeOptions = []
        }
      })
    },
  },
  async mounted() {
    const res = await fetchUserPermission({ permission_type: 'LASER' })
    if (res.status) {
      this.isLaserPermission = res.data.enable
    }
    // 挂载偏好设置的更新
    this.$preference.init(this.updatePreference, this.$route.path)

    this.handleGetLockStatus()
    if (this.$route.query.from) {
      if (this.$route.query.from == 'tiangong') {
        this.showTiangong = true
      }
    } else {
      this.showTiangong = false
      if (this.$route.query.tab === 'saw') {
        this.nowPage = 'sawEngraving'
      }
      this.loadEngraving()
    }
    this.handleKnifeType()
    this.$nextTick(() => {
      Navigate.getInstance().registerEvent(this.$route.path, {
        switchTab: this.changeNav,
        waitLoadDone: () => (this.ableSaveSetting ? 1 : 0),
      })
    })
  },
  beforeDestroy() {
    Navigate.getInstance().unregisterEvent('/engraving')
  },
}
</script>

<style scoped lang="less">
.engraving {
  min-width: 720px;
  height: 100%;

  .top-nav {
    .nav-item {
      display: inline-block;
      box-sizing: border-box;
      margin-right: 28px;
      padding: 13px 0;
      color: rgba(0, 0, 0, 0.8);
      font-size: 16px;
      cursor: pointer;
    }

    .ml25 {
      margin-left: 25px;
    }

    .active-nav {
      box-sizing: border-box;
      color: #18a8c7;
      border-bottom: 3px solid #18a8c7;
    }

    /deep/.robot-arm-nav {
      .new-button_text {
        right: -24px;
        top: -16px;
        width: 40px;
        background-color: #f9e0c7;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }

  .wrap {
    height: 0;
    padding: 16px;
    // min-width: 1703px;
    // overflow-x: auto;
  }
}
</style>
